var items = {
  "block.minecraft.acacia_button": "Акация баскычы",
  "block.minecraft.acacia_door": "Акация эшиги",
  "block.minecraft.acacia_fence": "Акация кашаа",
  "block.minecraft.acacia_fence_gate": "Акация дарбазасы",
  "block.minecraft.acacia_hanging_sign": "Асма акация тактачасы",
  "block.minecraft.acacia_leaves": "Акация жалбырагы",
  "block.minecraft.acacia_log": "Акация устуну",
  "block.minecraft.acacia_planks": "Акация тактай",
  "block.minecraft.acacia_pressure_plate": "Акация басым плитасы",
  "block.minecraft.acacia_sapling": "Акация көчөтү",
  "block.minecraft.acacia_shelf": "Акация текчеси",
  "block.minecraft.acacia_sign": "Акация тактача",
  "block.minecraft.acacia_slab": "Акация плитасы",
  "block.minecraft.acacia_stairs": "Акация тепкич",
  "block.minecraft.acacia_trapdoor": "Акация люк",
  "block.minecraft.acacia_wall_hanging_sign": "Дубалдагы асма акация тактачасы",
  "block.minecraft.acacia_wall_sign": "Дубалдагы акация тактачасы",
  "block.minecraft.acacia_wood": "Акация жыгачы",
  "block.minecraft.activator_rail": "Иштетүүчү рельс",
  "block.minecraft.air": "Аба",
  "block.minecraft.allium": "Пияз",
  "block.minecraft.amethyst_block": "Аметист блогу",
  "block.minecraft.amethyst_cluster": "Аметист кластери",
  "block.minecraft.ancient_debris": "Байыркы сынык",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезит плита",
  "block.minecraft.andesite_stairs": "Андезит тепкич",
  "block.minecraft.andesite_wall": "Андезит дубалы",
  "block.minecraft.anvil": "Дөшү",
  "block.minecraft.attached_melon_stem": "Жабышкан дарбыз сабагы",
  "block.minecraft.attached_pumpkin_stem": "Жабышкан ашкабак сабагы",
  "block.minecraft.azalea": "Азалия",
  "block.minecraft.azalea_leaves": "Азалия жалбырагы",
  "block.minecraft.azure_bluet": "Хаустония",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбук блогу",
  "block.minecraft.bamboo_button": "Бамбук баскычы",
  "block.minecraft.bamboo_door": "Бамбук эшик",
  "block.minecraft.bamboo_fence": "Бамбук кашаа",
  "block.minecraft.bamboo_fence_gate": "Бамбук дарбаза",
  "block.minecraft.bamboo_hanging_sign": "Асма бамбук тактачасы",
  "block.minecraft.bamboo_mosaic": "Бамбук мозаикасы",
  "block.minecraft.bamboo_mosaic_slab": "Бамбук мозаика плита",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбук мозаика тепкичи",
  "block.minecraft.bamboo_planks": "Бамбук тактай",
  "block.minecraft.bamboo_pressure_plate": "Бамбук басым плитасы",
  "block.minecraft.bamboo_sapling": "Бамбук жаш бутагы",
  "block.minecraft.bamboo_shelf": "Бамбук текче",
  "block.minecraft.bamboo_sign": "Бамбук тактача",
  "block.minecraft.bamboo_slab": "Бамбук плита",
  "block.minecraft.bamboo_stairs": "Бамбук тепкич",
  "block.minecraft.bamboo_trapdoor": "Бамбук люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Дубалдагы асма бамбук тактачасы",
  "block.minecraft.bamboo_wall_sign": "Дубалдагы бамбук тактачасы",
  "block.minecraft.banner.base.black": "Кара түстүү",
  "block.minecraft.banner.base.blue": "Көк түстүү",
  "block.minecraft.banner.base.brown": "Күрөң түстүү",
  "block.minecraft.banner.base.cyan": "Көгүш түстүү",
  "block.minecraft.banner.base.gray": "Боз түстүү",
  "block.minecraft.banner.base.green": "Жашыл түстүү",
  "block.minecraft.banner.base.light_blue": "Көгүлтүр түстүү",
  "block.minecraft.banner.base.light_gray": "Ачык боз түстүү",
  "block.minecraft.banner.base.lime": "Лайм түстүү",
  "block.minecraft.banner.base.magenta": "Кара кочкул түстүү",
  "block.minecraft.banner.base.orange": "Кызгылт сары түстүү",
  "block.minecraft.banner.base.pink": "Кызгылт түстүү",
  "block.minecraft.banner.base.purple": "Кызгылт көк түстүү",
  "block.minecraft.banner.base.red": "Кызыл түстүү",
  "block.minecraft.banner.base.white": "Ак түстүү",
  "block.minecraft.banner.base.yellow": "Сары түстүү",
  "block.minecraft.banner.border.black": "Кара жээк",
  "block.minecraft.banner.border.blue": "Көк жээк",
  "block.minecraft.banner.border.brown": "Күрөң жээк",
  "block.minecraft.banner.border.cyan": "Көгүш жээк",
  "block.minecraft.banner.border.gray": "Боз жээк",
  "block.minecraft.banner.border.green": "Жашыл жээк",
  "block.minecraft.banner.border.light_blue": "Көгүлтүр жээк",
  "block.minecraft.banner.border.light_gray": "Ачык боз жээк",
  "block.minecraft.banner.border.lime": "Лайм жээк",
  "block.minecraft.banner.border.magenta": "Кара кочкул жээк",
  "block.minecraft.banner.border.orange": "Кызгылт сары жээк",
  "block.minecraft.banner.border.pink": "Кызгылт жээк",
  "block.minecraft.banner.border.purple": "Кызгылт көк жээк",
  "block.minecraft.banner.border.red": "Кызыл жээк",
  "block.minecraft.banner.border.white": "Ак жээк",
  "block.minecraft.banner.border.yellow": "Сары жээк",
  "block.minecraft.banner.bricks.black": "Кара кирпич",
  "block.minecraft.banner.bricks.blue": "Көк кирпич",
  "block.minecraft.banner.bricks.brown": "Күрөң кирпич",
  "block.minecraft.banner.bricks.cyan": "Көгүш кирпич",
  "block.minecraft.banner.bricks.gray": "Боз кирпич",
  "block.minecraft.banner.bricks.green": "Жашыл кирпич",
  "block.minecraft.banner.bricks.light_blue": "Көгүлтүр кирпич",
  "block.minecraft.banner.bricks.light_gray": "Ачык боз кирпич",
  "block.minecraft.banner.bricks.lime": "Лайм кирпич",
  "block.minecraft.banner.bricks.magenta": "Кара кочкул кирпич",
  "block.minecraft.banner.bricks.orange": "Кызгылт сары кирпич",
  "block.minecraft.banner.bricks.pink": "Кызгылт кирпич",
  "block.minecraft.banner.bricks.purple": "Кызгылт көк кирпич",
  "block.minecraft.banner.bricks.red": "Кызыл кирпич",
  "block.minecraft.banner.bricks.white": "Ак кирпич",
  "block.minecraft.banner.bricks.yellow": "Сары кирпич",
  "block.minecraft.banner.circle.black": "Кара тегерек",
  "block.minecraft.banner.circle.blue": "Көк тегерек",
  "block.minecraft.banner.circle.brown": "Күрөң тегерек",
  "block.minecraft.banner.circle.cyan": "Көгүш тегерек",
  "block.minecraft.banner.circle.gray": "Боз тегерек",
  "block.minecraft.banner.circle.green": "Жашыл тегерек",
  "block.minecraft.banner.circle.light_blue": "Көгүлтүр тегерек",
  "block.minecraft.banner.circle.light_gray": "Ачык боз тегерек",
  "block.minecraft.banner.circle.lime": "Лайм тегерек",
  "block.minecraft.banner.circle.magenta": "Кара кочкул тегерек",
  "block.minecraft.banner.circle.orange": "Кызгылт сары тегерек",
  "block.minecraft.banner.circle.pink": "Кызгылт тегерек",
  "block.minecraft.banner.circle.purple": "Кызгылт көк тегерек",
  "block.minecraft.banner.circle.red": "Кызыл тегерек",
  "block.minecraft.banner.circle.white": "Ак тегерек",
  "block.minecraft.banner.circle.yellow": "Сары тегерек",
  "block.minecraft.banner.creeper.black": "Кара крипер",
  "block.minecraft.banner.creeper.blue": "Көк крипер",
  "block.minecraft.banner.creeper.brown": "Күрөң крипер",
  "block.minecraft.banner.creeper.cyan": "Көгүш крипер",
  "block.minecraft.banner.creeper.gray": "Боз крипер",
  "block.minecraft.banner.creeper.green": "Жашыл крипер",
  "block.minecraft.banner.creeper.light_blue": "Көгүлтүр крипер",
  "block.minecraft.banner.creeper.light_gray": "Ачык боз крипер",
  "block.minecraft.banner.creeper.lime": "Лайм крипер",
  "block.minecraft.banner.creeper.magenta": "Кара кочкул крипер",
  "block.minecraft.banner.creeper.orange": "Кызгылт сары крипер",
  "block.minecraft.banner.creeper.pink": "Кызгылт крипер",
  "block.minecraft.banner.creeper.purple": "Кызгылт көк крипер",
  "block.minecraft.banner.creeper.red": "Кызыл крипер",
  "block.minecraft.banner.creeper.white": "Ак крипер",
  "block.minecraft.banner.creeper.yellow": "Сары крипер",
  "block.minecraft.banner.cross.black": "Кара айкыш",
  "block.minecraft.banner.cross.blue": "Көк айкыш",
  "block.minecraft.banner.cross.brown": "Күрөң айкыш",
  "block.minecraft.banner.cross.cyan": "Көгүш айкыш",
  "block.minecraft.banner.cross.gray": "Боз айкыш",
  "block.minecraft.banner.cross.green": "Жашыл айкыш",
  "block.minecraft.banner.cross.light_blue": "Көгүлтүр айкыш",
  "block.minecraft.banner.cross.light_gray": "Ачык боз айкыш",
  "block.minecraft.banner.cross.lime": "Лайм айкыш",
  "block.minecraft.banner.cross.magenta": "Кара кочкул айкыш",
  "block.minecraft.banner.cross.orange": "Кызгылт сары айкыш",
  "block.minecraft.banner.cross.pink": "Кызгылт айкыш",
  "block.minecraft.banner.cross.purple": "Кызгылт көк айкыш",
  "block.minecraft.banner.cross.red": "Кызыл айкыш",
  "block.minecraft.banner.cross.white": "Ак айкыш",
  "block.minecraft.banner.cross.yellow": "Сары айкыш",
  "block.minecraft.banner.curly_border.black": "Кара ийри жээк",
  "block.minecraft.banner.curly_border.blue": "Көк ийри жээк",
  "block.minecraft.banner.curly_border.brown": "Күрөң ийри жээк",
  "block.minecraft.banner.curly_border.cyan": "Көгүш ийри жээк",
  "block.minecraft.banner.curly_border.gray": "Боз ийри жээк",
  "block.minecraft.banner.curly_border.green": "Жашыл ийри жээк",
  "block.minecraft.banner.curly_border.light_blue": "Көгүлтүр ийри жээк",
  "block.minecraft.banner.curly_border.light_gray": "Ачык ийри боз жээк",
  "block.minecraft.banner.curly_border.lime": "Лайм ийри жээк",
  "block.minecraft.banner.curly_border.magenta": "Кара кочкул ийри жээк",
  "block.minecraft.banner.curly_border.orange": "Кызгылт сары ийри жээк",
  "block.minecraft.banner.curly_border.pink": "Кызгылт ийри жээк",
  "block.minecraft.banner.curly_border.purple": "Кызгылт көк ийри жээк",
  "block.minecraft.banner.curly_border.red": "Кызыл ийри жээк",
  "block.minecraft.banner.curly_border.white": "Ак ийри жээк",
  "block.minecraft.banner.curly_border.yellow": "Сары ийри жээк",
  "block.minecraft.banner.diagonal_left.black": "Кара сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.blue": "Көк сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.brown": "Күрөң сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.cyan": "Көгүш сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.gray": "Боз сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.green": "Жашыл сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.light_blue": "Көгүлтүр сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.light_gray": "Ачык боз сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.lime": "Лайм сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.magenta": "Кара кочкул сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.orange": "Кызгылт сары сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.pink": "Кызгылт сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.purple": "Кызгылт көк сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.red": "Кызыл сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.white": "Ак сол жак кыйгач",
  "block.minecraft.banner.diagonal_left.yellow": "Сары сол жак кыйгач",
  "block.minecraft.banner.diagonal_right.black": "Кара кыйгач",
  "block.minecraft.banner.diagonal_right.blue": "Көк кыйгач",
  "block.minecraft.banner.diagonal_right.brown": "Күрөң кыйгач",
  "block.minecraft.banner.diagonal_right.cyan": "Көгүш кыйгач",
  "block.minecraft.banner.diagonal_right.gray": "Боз кыйгач",
  "block.minecraft.banner.diagonal_right.green": "Жашыл кыйгач",
  "block.minecraft.banner.diagonal_right.light_blue": "Көгүлтүр кыйгач",
  "block.minecraft.banner.diagonal_right.light_gray": "Ачык боз кыйгач",
  "block.minecraft.banner.diagonal_right.lime": "Лайм кыйгач",
  "block.minecraft.banner.diagonal_right.magenta": "Кара кочкул кыйгач",
  "block.minecraft.banner.diagonal_right.orange": "Кызгылт сары кыйгач",
  "block.minecraft.banner.diagonal_right.pink": "Кызгылт кыйгач",
  "block.minecraft.banner.diagonal_right.purple": "Кызгылт көк кыйгач",
  "block.minecraft.banner.diagonal_right.red": "Кызыл кыйгач",
  "block.minecraft.banner.diagonal_right.white": "Ак кыйгач",
  "block.minecraft.banner.diagonal_right.yellow": "Сары кыйгач",
  "block.minecraft.banner.diagonal_up_left.black": "Кара терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.blue": "Көк терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.brown": "Күрөң терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.cyan": "Көгүш терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.gray": "Боз терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.green": "Жашыл терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Көгүлтүр терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ачык боз терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.lime": "Лайм терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.magenta": "Кара кочкул терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.orange": "Кызгылт сары терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.pink": "Кызгылт терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.purple": "Кызгылт көк терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.red": "Кызыл терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.white": "Ак терс кыйгач",
  "block.minecraft.banner.diagonal_up_left.yellow": "Сары терс кыйгач",
  "block.minecraft.banner.diagonal_up_right.black": "Кара терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.blue": "Көк терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.brown": "Күрөң терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.cyan": "Көгүш терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.gray": "Боз терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.green": "Жашыл терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Көгүлтүр терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ачык боз терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.lime": "Лайм терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.magenta": "Кара кочкул терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.orange": "Кызгылт сары терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.pink": "Кызгылт терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.purple": "Кызгылт көк терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.red": "Кызыл терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.white": "Ак терс сол жак кыйгач",
  "block.minecraft.banner.diagonal_up_right.yellow": "Сары терс сол жак кыйгач",
  "block.minecraft.banner.flow.black": "Кара агым",
  "block.minecraft.banner.flow.blue": "Көк агым",
  "block.minecraft.banner.flow.brown": "Күрөң агым",
  "block.minecraft.banner.flow.cyan": "Көгүш агым",
  "block.minecraft.banner.flow.gray": "Боз агым",
  "block.minecraft.banner.flow.green": "Жашыл агым",
  "block.minecraft.banner.flow.light_blue": "Көгүлтүр агым",
  "block.minecraft.banner.flow.light_gray": "Ачык боз агым",
  "block.minecraft.banner.flow.lime": "Лайм агым",
  "block.minecraft.banner.flow.magenta": "Кара кочкул агым",
  "block.minecraft.banner.flow.orange": "Кызгылт сары агым",
  "block.minecraft.banner.flow.pink": "Кызгылт агым",
  "block.minecraft.banner.flow.purple": "Кызгылт көк агым",
  "block.minecraft.banner.flow.red": "Кызыл агым",
  "block.minecraft.banner.flow.white": "Ак агым",
  "block.minecraft.banner.flow.yellow": "Сары агым",
  "block.minecraft.banner.flower.black": "Кара гүл",
  "block.minecraft.banner.flower.blue": "Көк гүл",
  "block.minecraft.banner.flower.brown": "Күрөң гүл",
  "block.minecraft.banner.flower.cyan": "Көгүш гүл",
  "block.minecraft.banner.flower.gray": "Боз гүл",
  "block.minecraft.banner.flower.green": "Жашыл гүл",
  "block.minecraft.banner.flower.light_blue": "Көгүлтүр гүл",
  "block.minecraft.banner.flower.light_gray": "Ачык боз гүл",
  "block.minecraft.banner.flower.lime": "Лайм гүл",
  "block.minecraft.banner.flower.magenta": "Кара кочкул гүл",
  "block.minecraft.banner.flower.orange": "Кызгылт сары гүл",
  "block.minecraft.banner.flower.pink": "Кызгылт гүл",
  "block.minecraft.banner.flower.purple": "Кызгылт көк гүл",
  "block.minecraft.banner.flower.red": "Кызыл гүл",
  "block.minecraft.banner.flower.white": "Ак гүл",
  "block.minecraft.banner.flower.yellow": "Сары гүл",
  "block.minecraft.banner.globe.black": "Кара глобус",
  "block.minecraft.banner.globe.blue": "Көк глобус",
  "block.minecraft.banner.globe.brown": "Күрөң глобус",
  "block.minecraft.banner.globe.cyan": "Көгүш глобус",
  "block.minecraft.banner.globe.gray": "Боз глобус",
  "block.minecraft.banner.globe.green": "Жашыл глобус",
  "block.minecraft.banner.globe.light_blue": "Көгүлтүр глобус",
  "block.minecraft.banner.globe.light_gray": "Ачык боз глобус",
  "block.minecraft.banner.globe.lime": "Лайм глобус",
  "block.minecraft.banner.globe.magenta": "Кара кочкул глобус",
  "block.minecraft.banner.globe.orange": "Кызгылт сары глобус",
  "block.minecraft.banner.globe.pink": "Кызгылт глобус",
  "block.minecraft.banner.globe.purple": "Кызгылт көк глобус",
  "block.minecraft.banner.globe.red": "Кызыл глобус",
  "block.minecraft.banner.globe.white": "Ак глобус",
  "block.minecraft.banner.globe.yellow": "Сары глобус",
  "block.minecraft.banner.gradient.black": "Кара градиент",
  "block.minecraft.banner.gradient.blue": "Көк градиент",
  "block.minecraft.banner.gradient.brown": "Күрөң градиент",
  "block.minecraft.banner.gradient.cyan": "Көгүш градиент",
  "block.minecraft.banner.gradient.gray": "Боз градиент",
  "block.minecraft.banner.gradient.green": "Жашыл градиент",
  "block.minecraft.banner.gradient.light_blue": "Көгүлтүр градиент",
  "block.minecraft.banner.gradient.light_gray": "Ачык боз градиент",
  "block.minecraft.banner.gradient.lime": "Лайм градиент",
  "block.minecraft.banner.gradient.magenta": "Кара кочкул градиент",
  "block.minecraft.banner.gradient.orange": "Кызгылт сары градиент",
  "block.minecraft.banner.gradient.pink": "Кызгылт градиент",
  "block.minecraft.banner.gradient.purple": "Кызгылт көк градиент",
  "block.minecraft.banner.gradient.red": "Кызыл градиент",
  "block.minecraft.banner.gradient.white": "Ак градиент",
  "block.minecraft.banner.gradient.yellow": "Сары градиент",
  "block.minecraft.banner.gradient_up.black": "Кара тескери градиент",
  "block.minecraft.banner.gradient_up.blue": "Көк тескери градиент",
  "block.minecraft.banner.gradient_up.brown": "Күрөң тескери градиент",
  "block.minecraft.banner.gradient_up.cyan": "Көгүш тескери градиент",
  "block.minecraft.banner.gradient_up.gray": "Ачык боз тескери градиент",
  "block.minecraft.banner.gradient_up.green": "Жашыл тескери градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Көгүлтүр тескери градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Ачык боз тескери градиент",
  "block.minecraft.banner.gradient_up.lime": "Лайм тескери градиент",
  "block.minecraft.banner.gradient_up.magenta": "Кара кочкул тескери градиент",
  "block.minecraft.banner.gradient_up.orange": "Кызгылт сары тескери градиент",
  "block.minecraft.banner.gradient_up.pink": "Кызгылт тескери градиент",
  "block.minecraft.banner.gradient_up.purple": "Кызгылт көк тескери градиент",
  "block.minecraft.banner.gradient_up.red": "Кызыл тескери градиент",
  "block.minecraft.banner.gradient_up.white": "Ак тескери градиент",
  "block.minecraft.banner.gradient_up.yellow": "Сары тескери градиент",
  "block.minecraft.banner.guster.black": "Кара куюн",
  "block.minecraft.banner.guster.blue": "Көк куюн",
  "block.minecraft.banner.guster.brown": "Күрөң куюн",
  "block.minecraft.banner.guster.cyan": "Көгүш куюн",
  "block.minecraft.banner.guster.gray": "Боз куюн",
  "block.minecraft.banner.guster.green": "Жашыл куюн",
  "block.minecraft.banner.guster.light_blue": "Көгүлтүр куюн",
  "block.minecraft.banner.guster.light_gray": "Ачык боз куюн",
  "block.minecraft.banner.guster.lime": "Лайм куюн",
  "block.minecraft.banner.guster.magenta": "Кара кочкул куюн",
  "block.minecraft.banner.guster.orange": "Кызгылт сары куюн",
  "block.minecraft.banner.guster.pink": "Кызгылт куюн",
  "block.minecraft.banner.guster.purple": "Кызгылт көк куюн",
  "block.minecraft.banner.guster.red": "Кызыл куюн",
  "block.minecraft.banner.guster.white": "Ак куюн",
  "block.minecraft.banner.guster.yellow": "Сары куюн",
  "block.minecraft.banner.half_horizontal.black": "Кара жогорку жак",
  "block.minecraft.banner.half_horizontal.blue": "Көк жогорку жак",
  "block.minecraft.banner.half_horizontal.brown": "Күрөң жогорку жак",
  "block.minecraft.banner.half_horizontal.cyan": "Көгүш үстүңкү жак",
  "block.minecraft.banner.half_horizontal.gray": "Боз жогорку жак",
  "block.minecraft.banner.half_horizontal.green": "Жашыл жогорку жак",
  "block.minecraft.banner.half_horizontal.light_blue": "Көгүлтүр жогорку жак",
  "block.minecraft.banner.half_horizontal.light_gray": "Ачык боз жогорку жак",
  "block.minecraft.banner.half_horizontal.lime": "Лайм жогорку жак",
  "block.minecraft.banner.half_horizontal.magenta": "Кара кочкул жогорку жак",
  "block.minecraft.banner.half_horizontal.orange": "Кызгылт сары үстүңкү жак",
  "block.minecraft.banner.half_horizontal.pink": "Кызгылт жогорку жак",
  "block.minecraft.banner.half_horizontal.purple": "Кызгылт көк жогорку жак",
  "block.minecraft.banner.half_horizontal.red": "Кызыл жогорку жак",
  "block.minecraft.banner.half_horizontal.white": "Ак жогорку жак",
  "block.minecraft.banner.half_horizontal.yellow": "Сары жогорку жак",
  "block.minecraft.banner.half_horizontal_bottom.black": "Кара астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Көк астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Күрөң астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Көгүш астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Боз астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.green": "Жашыл астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Көгүлтүр астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ачык боз астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Лайм астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Кара кочкул астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Кызгылт сары астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Кызгылт астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Кызгылт көк астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.red": "Кызыл астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.white": "Ак астыңкы жак",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Сары астыңкы жак",
  "block.minecraft.banner.half_vertical.black": "Кара сол жак",
  "block.minecraft.banner.half_vertical.blue": "Көк сол жак",
  "block.minecraft.banner.half_vertical.brown": "Күрөң сол жак",
  "block.minecraft.banner.half_vertical.cyan": "Көгүш сол жак",
  "block.minecraft.banner.half_vertical.gray": "Боз сол жак",
  "block.minecraft.banner.half_vertical.green": "Жашыл сол жак",
  "block.minecraft.banner.half_vertical.light_blue": "Көгүлтүр сол жак",
  "block.minecraft.banner.half_vertical.light_gray": "Ачык боз сол жак",
  "block.minecraft.banner.half_vertical.lime": "Лайм сол жак",
  "block.minecraft.banner.half_vertical.magenta": "Кара кочкул сол жак",
  "block.minecraft.banner.half_vertical.orange": "Кызгылт сары сол жак",
  "block.minecraft.banner.half_vertical.pink": "Кызгылт сол жак",
  "block.minecraft.banner.half_vertical.purple": "Кызгылт көк сол жак",
  "block.minecraft.banner.half_vertical.red": "Кызыл сол жак",
  "block.minecraft.banner.half_vertical.white": "Ак сол жак",
  "block.minecraft.banner.half_vertical.yellow": "Сары сол жак",
  "block.minecraft.banner.half_vertical_right.black": "Кара оң жак",
  "block.minecraft.banner.half_vertical_right.blue": "Көк оң жак",
  "block.minecraft.banner.half_vertical_right.brown": "Күрөң оң жак",
  "block.minecraft.banner.half_vertical_right.cyan": "Көгүш оң жак",
  "block.minecraft.banner.half_vertical_right.gray": "Боз оң жак",
  "block.minecraft.banner.half_vertical_right.green": "Жашыл оң жак",
  "block.minecraft.banner.half_vertical_right.light_blue": "Көгүлтүр оң жак",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ачык боз оң жак",
  "block.minecraft.banner.half_vertical_right.lime": "Лайм оң жак",
  "block.minecraft.banner.half_vertical_right.magenta": "Кара кочкул оң жак",
  "block.minecraft.banner.half_vertical_right.orange": "Кызгылт сары оң жак",
  "block.minecraft.banner.half_vertical_right.pink": "Кызгылт оң жак",
  "block.minecraft.banner.half_vertical_right.purple": "Кызгылт көк оң жак",
  "block.minecraft.banner.half_vertical_right.red": "Кызыл оң жак",
  "block.minecraft.banner.half_vertical_right.white": "Ак оң жак",
  "block.minecraft.banner.half_vertical_right.yellow": "Сары оң жак",
  "block.minecraft.banner.mojang.black": "Кара бирдеме",
  "block.minecraft.banner.mojang.blue": "Көк бирдеме",
  "block.minecraft.banner.mojang.brown": "Күрөң бирдеме",
  "block.minecraft.banner.mojang.cyan": "Көгүш бирдеме",
  "block.minecraft.banner.mojang.gray": "Боз бирдеме",
  "block.minecraft.banner.mojang.green": "Жашыл бирдеме",
  "block.minecraft.banner.mojang.light_blue": "Көгүлтүр бирдеме",
  "block.minecraft.banner.mojang.light_gray": "Ачык боз бирдеме",
  "block.minecraft.banner.mojang.lime": "Лайм бирдеме",
  "block.minecraft.banner.mojang.magenta": "Кара кочкул бирдеме",
  "block.minecraft.banner.mojang.orange": "Кызгылт сары бирдеме",
  "block.minecraft.banner.mojang.pink": "Кызгылт бирдеме",
  "block.minecraft.banner.mojang.purple": "Кызгылт көк бирдеме",
  "block.minecraft.banner.mojang.red": "Кызыл бирдеме",
  "block.minecraft.banner.mojang.white": "Ак бирдеме",
  "block.minecraft.banner.mojang.yellow": "Сары бирдеме",
  "block.minecraft.banner.piglin.black": "Кара тумшук",
  "block.minecraft.banner.piglin.blue": "Көк тумшук",
  "block.minecraft.banner.piglin.brown": "Күрөң тумшук",
  "block.minecraft.banner.piglin.cyan": "Көгүш тумшук",
  "block.minecraft.banner.piglin.gray": "Боз тумшук",
  "block.minecraft.banner.piglin.green": "Жашыл тумшук",
  "block.minecraft.banner.piglin.light_blue": "Көгүлтүр тумшук",
  "block.minecraft.banner.piglin.light_gray": "Ачык боз тумшук",
  "block.minecraft.banner.piglin.lime": "Лайм тумшук",
  "block.minecraft.banner.piglin.magenta": "Кара кочкул тумшук",
  "block.minecraft.banner.piglin.orange": "Кызгылт сары тумшук",
  "block.minecraft.banner.piglin.pink": "Кызгылт тумшук",
  "block.minecraft.banner.piglin.purple": "Кызгылт көк тумшук",
  "block.minecraft.banner.piglin.red": "Кызыл тумшук",
  "block.minecraft.banner.piglin.white": "Ак тумшук",
  "block.minecraft.banner.piglin.yellow": "Сары тумшук",
  "block.minecraft.banner.rhombus.black": "Кара ромб",
  "block.minecraft.banner.rhombus.blue": "Көк ромб",
  "block.minecraft.banner.rhombus.brown": "Күрөң ромб",
  "block.minecraft.banner.rhombus.cyan": "Көгүш ромб",
  "block.minecraft.banner.rhombus.gray": "Боз ромб",
  "block.minecraft.banner.rhombus.green": "Жашыл ромб",
  "block.minecraft.banner.rhombus.light_blue": "Көгүлтүр ромб",
  "block.minecraft.banner.rhombus.light_gray": "Ачык боз ромб",
  "block.minecraft.banner.rhombus.lime": "Лайм ромб",
  "block.minecraft.banner.rhombus.magenta": "Кара кочкул ромб",
  "block.minecraft.banner.rhombus.orange": "Кызгылт сары ромб",
  "block.minecraft.banner.rhombus.pink": "Кызгылт ромб",
  "block.minecraft.banner.rhombus.purple": "Кызгылт көк ромб",
  "block.minecraft.banner.rhombus.red": "Кызыл ромб",
  "block.minecraft.banner.rhombus.white": "Ак ромб",
  "block.minecraft.banner.rhombus.yellow": "Сары ромб",
  "block.minecraft.banner.skull.black": "Кара баш сөөк",
  "block.minecraft.banner.skull.blue": "Көк баш сөөк",
  "block.minecraft.banner.skull.brown": "Күрөң баш сөөк",
  "block.minecraft.banner.skull.cyan": "Көгүш баш сөөк",
  "block.minecraft.banner.skull.gray": "Боз баш сөөк",
  "block.minecraft.banner.skull.green": "Жашыл баш сөөк",
  "block.minecraft.banner.skull.light_blue": "Көгүлтүр баш сөөк",
  "block.minecraft.banner.skull.light_gray": "Ачык боз баш сөөк",
  "block.minecraft.banner.skull.lime": "Лайм баш сөөк",
  "block.minecraft.banner.skull.magenta": "Кара кочкул баш сөөк",
  "block.minecraft.banner.skull.orange": "Кызгылт сары баш сөөк",
  "block.minecraft.banner.skull.pink": "Кызгылт баш сөөк",
  "block.minecraft.banner.skull.purple": "Кызгылт көк баш сөөк",
  "block.minecraft.banner.skull.red": "Кызыл сөөк баш сөөк",
  "block.minecraft.banner.skull.white": "Ак сөөк баш сөөк",
  "block.minecraft.banner.skull.yellow": "Сары баш сөөк",
  "block.minecraft.banner.small_stripes.black": "Кара жол-жол",
  "block.minecraft.banner.small_stripes.blue": "Көк жол-жол",
  "block.minecraft.banner.small_stripes.brown": "Күрөң жол-жол",
  "block.minecraft.banner.small_stripes.cyan": "Көгүш жол-жол",
  "block.minecraft.banner.small_stripes.gray": "Боз жол-жол",
  "block.minecraft.banner.small_stripes.green": "Жашыл жол-жол",
  "block.minecraft.banner.small_stripes.light_blue": "Көгүлтүр жол-жол",
  "block.minecraft.banner.small_stripes.light_gray": "Ачык боз жол-жол",
  "block.minecraft.banner.small_stripes.lime": "Лайм жол-жол",
  "block.minecraft.banner.small_stripes.magenta": "Кара кочкул жол-жол",
  "block.minecraft.banner.small_stripes.orange": "Кызгылт сары жол-жол",
  "block.minecraft.banner.small_stripes.pink": "Кызгылт жол-жол",
  "block.minecraft.banner.small_stripes.purple": "Кызгылт көк жол-жол",
  "block.minecraft.banner.small_stripes.red": "Кызыл жол-жол",
  "block.minecraft.banner.small_stripes.white": "Ак жол-жол",
  "block.minecraft.banner.small_stripes.yellow": "Сары жол-жол",
  "block.minecraft.banner.square_bottom_left.black": "Кара сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.blue": "Көк сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.brown": "Күрөң сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.cyan": "Көгүш сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.gray": "Боз сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.green": "Жашыл сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.light_blue": "Көгүлтүр сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ачык боз сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.lime": "Лайм сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.magenta": "Кара кочкул сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.orange": "Кызгылт сары астыңкы жак",
  "block.minecraft.banner.square_bottom_left.pink": "Кызгылт сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.purple": "Кызгылт көк сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.red": "Кызыл сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.white": "Ак сол астыңкы жак",
  "block.minecraft.banner.square_bottom_left.yellow": "Сары сол астыңкы жак",
  "block.minecraft.banner.square_bottom_right.black": "Кара оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.blue": "Көк оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.brown": "Күрөң оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.cyan": "Көгүш оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.gray": "Боз оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.green": "Жашыл оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.light_blue": "Көгүлтүр оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ачык боз оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.lime": "Лайм оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.magenta": "Кара кочкул оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.orange": "Кызгылт сары оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.pink": "Кызгылт оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.purple": "Кызгылт көк оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.red": "Кызыл оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.white": "Ак оң астыңкы жак",
  "block.minecraft.banner.square_bottom_right.yellow": "Сары оң астыңкы жак",
  "block.minecraft.banner.square_top_left.black": "Кара оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.blue": "Көк оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.brown": "Күрөң оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.cyan": "Көгүш оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.gray": "Боз оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.green": "Жашыл оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.light_blue": "Көгүлтүр оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.light_gray": "Ачык боз оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.lime": "Лайм оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.magenta": "Кара кочкул оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.orange": "Кызгылт сары оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.pink": "Кызгылт оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.purple": "Кызгылт көк оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.red": "Кызыл оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.white": "Ак оң үстүнкү жак",
  "block.minecraft.banner.square_top_left.yellow": "Сары оң үстүнкү жак",
  "block.minecraft.banner.square_top_right.black": "Кара сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.blue": "Көк сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.brown": "Күрөң сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.cyan": "Көгүш сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.gray": "Боз сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.green": "Жашыл сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.light_blue": "Көгүлтүр сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.light_gray": "Ачык боз сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.lime": "Лайм сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.magenta": "Кара кочкул сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.orange": "Кызгылт сары сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.pink": "Кызгылт сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.purple": "Кызгылт көк сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.red": "Кызыл сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.white": "Ак сол үстүнкү жак",
  "block.minecraft.banner.square_top_right.yellow": "Сары сол үстүнкү жак",
  "block.minecraft.banner.straight_cross.black": "Кара кирес",
  "block.minecraft.banner.straight_cross.blue": "Көк кирес",
  "block.minecraft.banner.straight_cross.brown": "Күрөң кирес",
  "block.minecraft.banner.straight_cross.cyan": "Көгүш кирес",
  "block.minecraft.banner.straight_cross.gray": "Боз кирес",
  "block.minecraft.banner.straight_cross.green": "Жашыл кирес",
  "block.minecraft.banner.straight_cross.light_blue": "Көгүлтүр кирес",
  "block.minecraft.banner.straight_cross.light_gray": "Ачык боз кирес",
  "block.minecraft.banner.straight_cross.lime": "Лайм кирес",
  "block.minecraft.banner.straight_cross.magenta": "Кара кочкул кирес",
  "block.minecraft.banner.straight_cross.orange": "Кызгылт сары кирес",
  "block.minecraft.banner.straight_cross.pink": "Кызгылт кирес",
  "block.minecraft.banner.straight_cross.purple": "Кызгылт көк кирес",
  "block.minecraft.banner.straight_cross.red": "Кызыл кирес",
  "block.minecraft.banner.straight_cross.white": "Ак кирес",
  "block.minecraft.banner.straight_cross.yellow": "Сары кирес",
  "block.minecraft.banner.stripe_bottom.black": "Кара асты",
  "block.minecraft.banner.stripe_bottom.blue": "Көк асты",
  "block.minecraft.banner.stripe_bottom.brown": "Күрөң асты",
  "block.minecraft.banner.stripe_bottom.cyan": "Көгүш асты",
  "block.minecraft.banner.stripe_bottom.gray": "Боз асты",
  "block.minecraft.banner.stripe_bottom.green": "Жашыл асты",
  "block.minecraft.banner.stripe_bottom.light_blue": "Көгүлтүр асты",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ачык боз асты",
  "block.minecraft.banner.stripe_bottom.lime": "Лайм асты",
  "block.minecraft.banner.stripe_bottom.magenta": "Кара кочкул асты",
  "block.minecraft.banner.stripe_bottom.orange": "Кызгылт сары асты",
  "block.minecraft.banner.stripe_bottom.pink": "Кызгылт асты",
  "block.minecraft.banner.stripe_bottom.purple": "Кызгылт көк асты",
  "block.minecraft.banner.stripe_bottom.red": "Кызыл асты",
  "block.minecraft.banner.stripe_bottom.white": "Ак асты",
  "block.minecraft.banner.stripe_bottom.yellow": "Сары асты",
  "block.minecraft.banner.stripe_center.black": "Кара ортоңку тилке",
  "block.minecraft.banner.stripe_center.blue": "Көк ортоңку тилке",
  "block.minecraft.banner.stripe_center.brown": "Күрөң ортоңку тилке",
  "block.minecraft.banner.stripe_center.cyan": "Көгүш ортоңку тилке",
  "block.minecraft.banner.stripe_center.gray": "Боз ортоңку тилке",
  "block.minecraft.banner.stripe_center.green": "Жашыл ортоңку тилке",
  "block.minecraft.banner.stripe_center.light_blue": "Көгүлтүр ортоңку тилке",
  "block.minecraft.banner.stripe_center.light_gray": "Ачык боз ортоңку тилке",
  "block.minecraft.banner.stripe_center.lime": "Лайм ортоңку тилке",
  "block.minecraft.banner.stripe_center.magenta": "Кара кочкул ортоңку тилке",
  "block.minecraft.banner.stripe_center.orange": "Кызгылт сары ортоңку тилке",
  "block.minecraft.banner.stripe_center.pink": "Кызгылт ортоңку тилке",
  "block.minecraft.banner.stripe_center.purple": "Кызгылт көк ортоңку тилке",
  "block.minecraft.banner.stripe_center.red": "Кызыл ортоңку тилке",
  "block.minecraft.banner.stripe_center.white": "Ак ортоңку тилке",
  "block.minecraft.banner.stripe_center.yellow": "Сары ортоңку тилке",
  "block.minecraft.banner.stripe_downleft.black": "Кара тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.blue": "Көк тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.brown": "Күрөң тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.cyan": "Көгүш тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.gray": "Боз тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.green": "Жашыл тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.light_blue": "Көгүлтүр тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ачык боз тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.lime": "Лайм тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.magenta": "Кара кочкул тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.orange": "Кызгылт сары тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.pink": "Кызгылт тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.purple": "Кызгылт көк тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.red": "Кызыл тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.white": "Ак тескери ийри тилке",
  "block.minecraft.banner.stripe_downleft.yellow": "Сары тескери ийри тилке",
  "block.minecraft.banner.stripe_downright.black": "Кара ийри тилке",
  "block.minecraft.banner.stripe_downright.blue": "Көк ийри тилке",
  "block.minecraft.banner.stripe_downright.brown": "Күрөң ийри тилке",
  "block.minecraft.banner.stripe_downright.cyan": "Көгүш ийри тилке",
  "block.minecraft.banner.stripe_downright.gray": "Боз ийри тилке",
  "block.minecraft.banner.stripe_downright.green": "Жашыл ийри тилке",
  "block.minecraft.banner.stripe_downright.light_blue": "Көгүлтүр ийри тилке",
  "block.minecraft.banner.stripe_downright.light_gray": "Ачык боз ийри тилке",
  "block.minecraft.banner.stripe_downright.lime": "Лайм ийри тилке",
  "block.minecraft.banner.stripe_downright.magenta": "Кара кочкул ийри тилке",
  "block.minecraft.banner.stripe_downright.orange": "Кызгылт сары ийри тилке",
  "block.minecraft.banner.stripe_downright.pink": "Кызгылт ийри тилке",
  "block.minecraft.banner.stripe_downright.purple": "Кызгылт көк ийри тилке",
  "block.minecraft.banner.stripe_downright.red": "Кызыл ийри тилке",
  "block.minecraft.banner.stripe_downright.white": "Ак ийри тилке",
  "block.minecraft.banner.stripe_downright.yellow": "Сары ийри тилке",
  "block.minecraft.banner.stripe_left.black": "Кара сол жак тилке",
  "block.minecraft.banner.stripe_left.blue": "Көк сол жак тилке",
  "block.minecraft.banner.stripe_left.brown": "Күрөң сол жак тилке",
  "block.minecraft.banner.stripe_left.cyan": "Көгүш сол жак тилке",
  "block.minecraft.banner.stripe_left.gray": "Боз сол жак тилке",
  "block.minecraft.banner.stripe_left.green": "Жашыл сол жак тилке",
  "block.minecraft.banner.stripe_left.light_blue": "Көгүлтүр сол жак тилке",
  "block.minecraft.banner.stripe_left.light_gray": "Ачык боз сол жак тилке",
  "block.minecraft.banner.stripe_left.lime": "Лайм сол жак тилке",
  "block.minecraft.banner.stripe_left.magenta": "Кара кочкул сол жак тилке",
  "block.minecraft.banner.stripe_left.orange": "Кызгылт сары сол жак тилке",
  "block.minecraft.banner.stripe_left.pink": "Кызгылт сол жак тилке",
  "block.minecraft.banner.stripe_left.purple": "Кызгылт көк сол жак тилке",
  "block.minecraft.banner.stripe_left.red": "Кызыл сол жак тилке",
  "block.minecraft.banner.stripe_left.white": "Ак сол жак тилке",
  "block.minecraft.banner.stripe_left.yellow": "Сары сол жак тилке",
  "block.minecraft.banner.stripe_middle.black": "Кара тилке",
  "block.minecraft.banner.stripe_middle.blue": "Көк тилке",
  "block.minecraft.banner.stripe_middle.brown": "Күрөң тилке",
  "block.minecraft.banner.stripe_middle.cyan": "Көгүш тилке",
  "block.minecraft.banner.stripe_middle.gray": "Боз тилке",
  "block.minecraft.banner.stripe_middle.green": "Жашыл тилке",
  "block.minecraft.banner.stripe_middle.light_blue": "Көгүлтүр тилке",
  "block.minecraft.banner.stripe_middle.light_gray": "Ачык боз тилке",
  "block.minecraft.banner.stripe_middle.lime": "Лайм тилке",
  "block.minecraft.banner.stripe_middle.magenta": "Кара кочкул тилке",
  "block.minecraft.banner.stripe_middle.orange": "Кызгылт сары тилке",
  "block.minecraft.banner.stripe_middle.pink": "Кызгылт тилке",
  "block.minecraft.banner.stripe_middle.purple": "Кызгылт көк тилке",
  "block.minecraft.banner.stripe_middle.red": "Кызыл тилке",
  "block.minecraft.banner.stripe_middle.white": "Ак тилке",
  "block.minecraft.banner.stripe_middle.yellow": "Сары тилке",
  "block.minecraft.banner.stripe_right.black": "Кара оң жак тилке",
  "block.minecraft.banner.stripe_right.blue": "Көк оң жак тилке",
  "block.minecraft.banner.stripe_right.brown": "Күрөң оң жак тилке",
  "block.minecraft.banner.stripe_right.cyan": "Көгүш оң жак тилке",
  "block.minecraft.banner.stripe_right.gray": "Боз оң жак тилке",
  "block.minecraft.banner.stripe_right.green": "Жашыл оң жак тилке",
  "block.minecraft.banner.stripe_right.light_blue": "Көгүлтүр оң жак тилке",
  "block.minecraft.banner.stripe_right.light_gray": "Ачык боз оң жак тилке",
  "block.minecraft.banner.stripe_right.lime": "Лайм боз оң жак тилке",
  "block.minecraft.banner.stripe_right.magenta": "Кара кочкул оң жак тилке",
  "block.minecraft.banner.stripe_right.orange": "Кызгылт сары оң жак тилке",
  "block.minecraft.banner.stripe_right.pink": "Кызгылт оң жак тилке",
  "block.minecraft.banner.stripe_right.purple": "Кызгылт көк оң жак тилке",
  "block.minecraft.banner.stripe_right.red": "Кызыл оң жак тилке",
  "block.minecraft.banner.stripe_right.white": "Ак оң жак тилке",
  "block.minecraft.banner.stripe_right.yellow": "Сары оң жак тилке",
  "block.minecraft.banner.stripe_top.black": "Кара үстү",
  "block.minecraft.banner.stripe_top.blue": "Көк үстү",
  "block.minecraft.banner.stripe_top.brown": "Күрөң үстү",
  "block.minecraft.banner.stripe_top.cyan": "Көгүш үстү",
  "block.minecraft.banner.stripe_top.gray": "Боз үстү",
  "block.minecraft.banner.stripe_top.green": "Жашыл үстү",
  "block.minecraft.banner.stripe_top.light_blue": "Көгүлтүр үстү",
  "block.minecraft.banner.stripe_top.light_gray": "Ачык боз үстү",
  "block.minecraft.banner.stripe_top.lime": "Лайм үстү",
  "block.minecraft.banner.stripe_top.magenta": "Кара кочкул үстү",
  "block.minecraft.banner.stripe_top.orange": "Кызгылт сары үстү",
  "block.minecraft.banner.stripe_top.pink": "Кызгылт үстү",
  "block.minecraft.banner.stripe_top.purple": "Кызгылт көк үстү",
  "block.minecraft.banner.stripe_top.red": "Кызыл үстү",
  "block.minecraft.banner.stripe_top.white": "Ак үстү",
  "block.minecraft.banner.stripe_top.yellow": "Сары үстү",
  "block.minecraft.banner.triangle_bottom.black": "Кара уч",
  "block.minecraft.banner.triangle_bottom.blue": "Көк уч",
  "block.minecraft.banner.triangle_bottom.brown": "Күрөң уч",
  "block.minecraft.banner.triangle_bottom.cyan": "Көгүш уч",
  "block.minecraft.banner.triangle_bottom.gray": "Боз уч",
  "block.minecraft.banner.triangle_bottom.green": "Жашыл уч",
  "block.minecraft.banner.triangle_bottom.light_blue": "Көгүлтүр уч",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ачык боз уч",
  "block.minecraft.banner.triangle_bottom.lime": "Лайм уч",
  "block.minecraft.banner.triangle_bottom.magenta": "Кара кочкул уч",
  "block.minecraft.banner.triangle_bottom.orange": "Кызгылт сары уч",
  "block.minecraft.banner.triangle_bottom.pink": "Кызгылт уч",
  "block.minecraft.banner.triangle_bottom.purple": "Кызгылт көк уч",
  "block.minecraft.banner.triangle_bottom.red": "Кызыл уч",
  "block.minecraft.banner.triangle_bottom.white": "Ак уч",
  "block.minecraft.banner.triangle_bottom.yellow": "Сары уч",
  "block.minecraft.banner.triangle_top.black": "Кара тескери уч",
  "block.minecraft.banner.triangle_top.blue": "Көк тескери уч",
  "block.minecraft.banner.triangle_top.brown": "Күрөң тескери уч",
  "block.minecraft.banner.triangle_top.cyan": "Көгүш тескери уч",
  "block.minecraft.banner.triangle_top.gray": "Боз тескери уч",
  "block.minecraft.banner.triangle_top.green": "Жашыл тескери уч",
  "block.minecraft.banner.triangle_top.light_blue": "Көгүлтүр тескери уч",
  "block.minecraft.banner.triangle_top.light_gray": "Ачык боз тескери уч",
  "block.minecraft.banner.triangle_top.lime": "Лайм тескери уч",
  "block.minecraft.banner.triangle_top.magenta": "Кара кочкул тескери уч",
  "block.minecraft.banner.triangle_top.orange": "Кызгылт сары тескери уч",
  "block.minecraft.banner.triangle_top.pink": "Кызгылт тескери уч",
  "block.minecraft.banner.triangle_top.purple": "Кызгылт көк тескери уч",
  "block.minecraft.banner.triangle_top.red": "Кызыл тескери уч",
  "block.minecraft.banner.triangle_top.white": "Ак тескери уч",
  "block.minecraft.banner.triangle_top.yellow": "Сары тескери уч",
  "block.minecraft.banner.triangles_bottom.black": "Кара тиштүү асты",
  "block.minecraft.banner.triangles_bottom.blue": "Көк тиштүү асты",
  "block.minecraft.banner.triangles_bottom.brown": "Күрөң тиштүү асты",
  "block.minecraft.banner.triangles_bottom.cyan": "Көгүш тиштүү асты",
  "block.minecraft.banner.triangles_bottom.gray": "Боз тиштүү асты",
  "block.minecraft.banner.triangles_bottom.green": "Жашыл тиштүү асты",
  "block.minecraft.banner.triangles_bottom.light_blue": "Көгүлтүр тиштүү асты",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ачык боз тиштүү асты",
  "block.minecraft.banner.triangles_bottom.lime": "Лайм тиштүү асты",
  "block.minecraft.banner.triangles_bottom.magenta": "Кара кочкул тиштүү асты",
  "block.minecraft.banner.triangles_bottom.orange": "Кызгылт сары тиштүү асты",
  "block.minecraft.banner.triangles_bottom.pink": "Кызгылт тиштүү асты",
  "block.minecraft.banner.triangles_bottom.purple": "Кызгылт көк тиштүү асты",
  "block.minecraft.banner.triangles_bottom.red": "Кызыл тиштүү асты",
  "block.minecraft.banner.triangles_bottom.white": "Ак тиштүү асты",
  "block.minecraft.banner.triangles_bottom.yellow": "Сары тиштүү асты",
  "block.minecraft.banner.triangles_top.black": "Кара тиштүү үстү",
  "block.minecraft.banner.triangles_top.blue": "Көк тиштүү үстү",
  "block.minecraft.banner.triangles_top.brown": "Күрөң тиштүү үстү",
  "block.minecraft.banner.triangles_top.cyan": "Көгүш тиштүү үстү",
  "block.minecraft.banner.triangles_top.gray": "Боз тиштүү үстү",
  "block.minecraft.banner.triangles_top.green": "Жашыл тиштүү үстү",
  "block.minecraft.banner.triangles_top.light_blue": "Көгүлтүр тиштүү үстү",
  "block.minecraft.banner.triangles_top.light_gray": "Ачык боз тиштүү үстү",
  "block.minecraft.banner.triangles_top.lime": "Лайм тиштүү үстү",
  "block.minecraft.banner.triangles_top.magenta": "Кара кочкул тиштүү үстү",
  "block.minecraft.banner.triangles_top.orange": "Кызгылт сары тиштүү үстү",
  "block.minecraft.banner.triangles_top.pink": "Кызгылт тиштүү үстү",
  "block.minecraft.banner.triangles_top.purple": "Кызгылт көк тиштүү үстү",
  "block.minecraft.banner.triangles_top.red": "Кызыл тиштүү үстү",
  "block.minecraft.banner.triangles_top.white": "Ак тиштүү үстү",
  "block.minecraft.banner.triangles_top.yellow": "Сары тиштүү үстү",
  "block.minecraft.barrel": "Челек",
  "block.minecraft.barrier": "Тоскоол",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Негизги күчү",
  "block.minecraft.beacon.secondary": "Экинчи күчү",
  "block.minecraft.bed.no_sleep": "Түндө же күн бүркөлгөндө гана уктай аласыз",
  "block.minecraft.bed.not_safe": "Азыр уктай албайсыз, жаныңызда мокочо бар",
  "block.minecraft.bed.obstructed": "Бул керебет бөгөттөлгөн",
  "block.minecraft.bed.occupied": "Бул керебет бош эмес",
  "block.minecraft.bed.too_far_away": "Жата албайсыз: керебет өтө алыс",
  "block.minecraft.bedrock": "Бедрок",
  "block.minecraft.bee_nest": "Аары уясы",
  "block.minecraft.beehive": "Бал челек",
  "block.minecraft.beetroots": "Кызылча",
  "block.minecraft.bell": "Коңгуроо",
  "block.minecraft.big_dripleaf": "Чоң тамчы жалбырак",
  "block.minecraft.big_dripleaf_stem": "Чоң тамчы жалбырак сабагы",
  "block.minecraft.birch_button": "Кайың баскыч",
  "block.minecraft.birch_door": "Кайың эшик",
  "block.minecraft.birch_fence": "Кайың кашаа",
  "block.minecraft.birch_fence_gate": "Кайың дарбаза",
  "block.minecraft.birch_hanging_sign": "Асма кайың тактача",
  "block.minecraft.birch_leaves": "Кайың жалбырагы",
  "block.minecraft.birch_log": "Кайың устуну",
  "block.minecraft.birch_planks": "Кайың тактай",
  "block.minecraft.birch_pressure_plate": "Кайың басым плитасы",
  "block.minecraft.birch_sapling": "Кайың көчөтү",
  "block.minecraft.birch_shelf": "Кайың текче",
  "block.minecraft.birch_sign": "Кайың тактача",
  "block.minecraft.birch_slab": "Кайың плита",
  "block.minecraft.birch_stairs": "Кайың тепкич",
  "block.minecraft.birch_trapdoor": "Кайың люк",
  "block.minecraft.birch_wall_hanging_sign": "Дубалдагы асма кайың тактачасы",
  "block.minecraft.birch_wall_sign": "Дубалдагы кайың тактачасы",
  "block.minecraft.birch_wood": "Кайың жыгачы",
  "block.minecraft.black_banner": "Кара желек",
  "block.minecraft.black_bed": "Кара керебет",
  "block.minecraft.black_candle": "Кара мом шам",
  "block.minecraft.black_candle_cake": "Кара мом шамдуу торт",
  "block.minecraft.black_carpet": "Кара килем",
  "block.minecraft.black_concrete": "Кара бетон",
  "block.minecraft.black_concrete_powder": "Кара цемент",
  "block.minecraft.black_glazed_terracotta": "Кара глазирленген бышкан чопо",
  "block.minecraft.black_shulker_box": "Кара шалкер кутусу",
  "block.minecraft.black_stained_glass": "Кара айнек",
  "block.minecraft.black_stained_glass_pane": "Кара терезе айнеги",
  "block.minecraft.black_terracotta": "Кара бышкан чопо",
  "block.minecraft.black_wool": "Кара жүн",
  "block.minecraft.blackstone": "Кара таш",
  "block.minecraft.blackstone_slab": "Кара таш плита",
  "block.minecraft.blackstone_stairs": "Кара таш тепкич",
  "block.minecraft.blackstone_wall": "Кара таш дубал",
  "block.minecraft.blast_furnace": "Эритүүчү меш",
  "block.minecraft.blue_banner": "Көк желек",
  "block.minecraft.blue_bed": "Көк керебет",
  "block.minecraft.blue_candle": "Көк мом шам",
  "block.minecraft.blue_candle_cake": "Көк мом шамдуу торт",
  "block.minecraft.blue_carpet": "Көк килем",
  "block.minecraft.blue_concrete": "Көк бетон",
  "block.minecraft.blue_concrete_powder": "Көк цемент",
  "block.minecraft.blue_glazed_terracotta": "Көк глазирленген бышкан чопо",
  "block.minecraft.blue_ice": "Көк муз",
  "block.minecraft.blue_orchid": "Көк орхидея",
  "block.minecraft.blue_shulker_box": "Көк шалкер кутусу",
  "block.minecraft.blue_stained_glass": "Көк айнек",
  "block.minecraft.blue_stained_glass_pane": "Көк терезе айнеги",
  "block.minecraft.blue_terracotta": "Көк бышкан чопо",
  "block.minecraft.blue_wool": "Көк жүн",
  "block.minecraft.bone_block": "Сөөк блогу",
  "block.minecraft.bookshelf": "Китеп текче",
  "block.minecraft.brain_coral": "Мээ шуру",
  "block.minecraft.brain_coral_block": "Мээ шуру блогу",
  "block.minecraft.brain_coral_fan": "Желпингич мээ шуру",
  "block.minecraft.brain_coral_wall_fan": "Дубалдагы желпингич мээ шурусу",
  "block.minecraft.brewing_stand": "Кайнаткыч",
  "block.minecraft.brick_slab": "Кирпич плита",
  "block.minecraft.brick_stairs": "Кирпич тепкич",
  "block.minecraft.brick_wall": "Кирпич дубал",
  "block.minecraft.bricks": "Кирпич",
  "block.minecraft.brown_banner": "Күрөң желек",
  "block.minecraft.brown_bed": "Күрөң керебет",
  "block.minecraft.brown_candle": "Күрөң мом шам",
  "block.minecraft.brown_candle_cake": "Күрөң мом шамдуу торт",
  "block.minecraft.brown_carpet": "Күрөң килем",
  "block.minecraft.brown_concrete": "Күрөң бетон",
  "block.minecraft.brown_concrete_powder": "Күрөң цемент",
  "block.minecraft.brown_glazed_terracotta": "Күрөң глазирленген бышкан чопо",
  "block.minecraft.brown_mushroom": "Күрөң козу карын",
  "block.minecraft.brown_mushroom_block": "Күрөң козу карын блогу",
  "block.minecraft.brown_shulker_box": "Күрөң шалкер кутусу",
  "block.minecraft.brown_stained_glass": "Күрөң айнек",
  "block.minecraft.brown_stained_glass_pane": "Күрөң терезе айнеги",
  "block.minecraft.brown_terracotta": "Күрөң бышкан чопо",
  "block.minecraft.brown_wool": "Күрөң жүн",
  "block.minecraft.bubble_column": "Көбүк түркүгү",
  "block.minecraft.bubble_coral": "Көбүкчөлүү шуру",
  "block.minecraft.bubble_coral_block": "Көбүкчөлүү шуру блогу",
  "block.minecraft.bubble_coral_fan": "Желпингич көбүкчөлүү шуру",
  "block.minecraft.bubble_coral_wall_fan": "Дубалдагы желпингич көбүкчөлүү шуру",
  "block.minecraft.budding_amethyst": "Гүлдөгөн аметист",
  "block.minecraft.bush": "Бадал",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактус гүлү",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Калибрленген скалк сенсор",
  "block.minecraft.campfire": "Очок",
  "block.minecraft.candle": "Мом шам",
  "block.minecraft.candle_cake": "Мом шамдуу торт",
  "block.minecraft.carrots": "Сабиз",
  "block.minecraft.cartography_table": "Картограф үстөлү",
  "block.minecraft.carved_pumpkin": "Оюлган ашкабак",
  "block.minecraft.cauldron": "Казан",
  "block.minecraft.cave_air": "Үңкүр абасы",
  "block.minecraft.cave_vines": "Үңкүр лианасы",
  "block.minecraft.cave_vines_plant": "Үңкүр лиана сабагы",
  "block.minecraft.chain": "Чынжыр",
  "block.minecraft.chain_command_block": "Тизмектик команда блогу",
  "block.minecraft.cherry_button": "Чие баскыч",
  "block.minecraft.cherry_door": "Чие эшик",
  "block.minecraft.cherry_fence": "Чие кашаа",
  "block.minecraft.cherry_fence_gate": "Чие дарбаза",
  "block.minecraft.cherry_hanging_sign": "Асма чие тактача",
  "block.minecraft.cherry_leaves": "Чие жалбырагы",
  "block.minecraft.cherry_log": "Чие устуну",
  "block.minecraft.cherry_planks": "Чие тактай",
  "block.minecraft.cherry_pressure_plate": "Чие басым плитасы",
  "block.minecraft.cherry_sapling": "Чие көчөтү",
  "block.minecraft.cherry_shelf": "Чие текче",
  "block.minecraft.cherry_sign": "Чие тактача",
  "block.minecraft.cherry_slab": "Чие плита",
  "block.minecraft.cherry_stairs": "Чие тепкич",
  "block.minecraft.cherry_trapdoor": "Чие люк",
  "block.minecraft.cherry_wall_hanging_sign": "Дубалдагы асма чие тактачасы",
  "block.minecraft.cherry_wall_sign": "Чие дубал тактачасы",
  "block.minecraft.cherry_wood": "Чие жыгачы",
  "block.minecraft.chest": "Сандык",
  "block.minecraft.chipped_anvil": "Жарака кеткен дөшү",
  "block.minecraft.chiseled_bookshelf": "Оюлган китеп текчеси",
  "block.minecraft.chiseled_copper": "Оюлган жез",
  "block.minecraft.chiseled_deepslate": "Оюлган катмар таш",
  "block.minecraft.chiseled_nether_bricks": "Оюлган незер кирпичи",
  "block.minecraft.chiseled_polished_blackstone": "Оюлган жылмаланган кара таш",
  "block.minecraft.chiseled_quartz_block": "Оюлган кварц блогу",
  "block.minecraft.chiseled_red_sandstone": "Оюлган кызыл кум таш",
  "block.minecraft.chiseled_resin_bricks": "Оюлган чайыр кирпич",
  "block.minecraft.chiseled_sandstone": "Оюлган кум таш",
  "block.minecraft.chiseled_stone_bricks": "Оюлган таш кирпич",
  "block.minecraft.chiseled_tuff": "Оюлган туф",
  "block.minecraft.chiseled_tuff_bricks": "Оюлган туф кирпич",
  "block.minecraft.chorus_flower": "Корус гүлү",
  "block.minecraft.chorus_plant": "Корус",
  "block.minecraft.clay": "Чопо",
  "block.minecraft.closed_eyeblossom": "Жабык карек гүл",
  "block.minecraft.coal_block": "Көмүр блогу",
  "block.minecraft.coal_ore": "Көмүр кени",
  "block.minecraft.coarse_dirt": "Таштуу топурак",
  "block.minecraft.cobbled_deepslate": "Жарылган катмар таш",
  "block.minecraft.cobbled_deepslate_slab": "Жарылган катмар таш плита",
  "block.minecraft.cobbled_deepslate_stairs": "Жарылган катмар таш тепкич",
  "block.minecraft.cobbled_deepslate_wall": "Жарылган катмар таш дубал",
  "block.minecraft.cobblestone": "Сай таш",
  "block.minecraft.cobblestone_slab": "Сай таш плита",
  "block.minecraft.cobblestone_stairs": "Сай таш тепкич",
  "block.minecraft.cobblestone_wall": "Сай таш дубал",
  "block.minecraft.cobweb": "Жөргөмүш тору",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Команда блогу",
  "block.minecraft.comparator": "Редстоун салыштыргыч",
  "block.minecraft.composter": "Компост челек",
  "block.minecraft.conduit": "Деңиз булагы",
  "block.minecraft.copper_bars": "Жез тор",
  "block.minecraft.copper_block": "Жез блогу",
  "block.minecraft.copper_bulb": "Жез шам",
  "block.minecraft.copper_chain": "Жез чынжыр",
  "block.minecraft.copper_chest": "Жез сандык",
  "block.minecraft.copper_door": "Жез эшик",
  "block.minecraft.copper_golem_statue": "Жез големдин айкели",
  "block.minecraft.copper_grate": "Жез тор",
  "block.minecraft.copper_lantern": "Жез чырак",
  "block.minecraft.copper_ore": "Жез кени",
  "block.minecraft.copper_torch": "Жез шамана",
  "block.minecraft.copper_trapdoor": "Жез люк",
  "block.minecraft.copper_wall_torch": "Дубалдагы жез шамана",
  "block.minecraft.cornflower": "Көк кекире",
  "block.minecraft.cracked_deepslate_bricks": "Сынган катмар таш кирпич",
  "block.minecraft.cracked_deepslate_tiles": "Сынган катмар таш плитняк",
  "block.minecraft.cracked_nether_bricks": "Сынган незер кирпич",
  "block.minecraft.cracked_polished_blackstone_bricks": "Сынган жылмаланган кара таш",
  "block.minecraft.cracked_stone_bricks": "Сынган таш кирпич",
  "block.minecraft.crafter": "Жасагыч",
  "block.minecraft.crafting_table": "Жасоо үстөлү",
  "block.minecraft.creaking_heart": "Кычырак жүрɵк",
  "block.minecraft.creeper_head": "Крипер башы",
  "block.minecraft.creeper_wall_head": "Дубалдагы крипер башы",
  "block.minecraft.crimson_button": "Кырмызы баскыч",
  "block.minecraft.crimson_door": "Кырмызы эшик",
  "block.minecraft.crimson_fence": "Кырмызы кашаа",
  "block.minecraft.crimson_fence_gate": "Кырмызы дарбаза",
  "block.minecraft.crimson_fungus": "Кырмызы козу карын",
  "block.minecraft.crimson_hanging_sign": "Асма кырмызы тактача",
  "block.minecraft.crimson_hyphae": "Кырмызы гифа",
  "block.minecraft.crimson_nylium": "Кырмызы нилий",
  "block.minecraft.crimson_planks": "Кырмызы тактай",
  "block.minecraft.crimson_pressure_plate": "Кырмызы басым плитасы",
  "block.minecraft.crimson_roots": "Кырмызы тамырлар",
  "block.minecraft.crimson_shelf": "Кырмызы текче",
  "block.minecraft.crimson_sign": "Кырмызы тактача",
  "block.minecraft.crimson_slab": "Кырмызы плита",
  "block.minecraft.crimson_stairs": "Кырмызы тепкич",
  "block.minecraft.crimson_stem": "Кырмызы сабак",
  "block.minecraft.crimson_trapdoor": "Кырмызы люк",
  "block.minecraft.crimson_wall_hanging_sign": "Дубалдагы асма кырмызы тактачасы",
  "block.minecraft.crimson_wall_sign": "Дубалдагы кырмызы тактачасы",
  "block.minecraft.crying_obsidian": "Ыйлачу обсидиан",
  "block.minecraft.cut_copper": "Кесилген жез",
  "block.minecraft.cut_copper_slab": "Кесилген жез плита",
  "block.minecraft.cut_copper_stairs": "Кесилген жез тепкич",
  "block.minecraft.cut_red_sandstone": "Кесилген кызыл кум таш",
  "block.minecraft.cut_red_sandstone_slab": "Кесилген кызыл кум таш плита",
  "block.minecraft.cut_sandstone": "Кесилген кум таш",
  "block.minecraft.cut_sandstone_slab": "Кесилген кум таш плита",
  "block.minecraft.cyan_banner": "Көгүш желек",
  "block.minecraft.cyan_bed": "Көгүш керебет",
  "block.minecraft.cyan_candle": "Көгүш мом шам",
  "block.minecraft.cyan_candle_cake": "Көгүш мом шамдуу торт",
  "block.minecraft.cyan_carpet": "Көгүш килем",
  "block.minecraft.cyan_concrete": "Көгүш бетон",
  "block.minecraft.cyan_concrete_powder": "Көгүш цемент",
  "block.minecraft.cyan_glazed_terracotta": "Көгүш глазирленген бышкан чопо",
  "block.minecraft.cyan_shulker_box": "Көгүш шалкер кутусу",
  "block.minecraft.cyan_stained_glass": "Көгүш айнек",
  "block.minecraft.cyan_stained_glass_pane": "Көгүш терезе айнеги",
  "block.minecraft.cyan_terracotta": "Көгүш бышкан чопо",
  "block.minecraft.cyan_wool": "Көгүш жүн",
  "block.minecraft.damaged_anvil": "Сынган дөшү",
  "block.minecraft.dandelion": "Каакым",
  "block.minecraft.dark_oak_button": "Кара эмен баскыч",
  "block.minecraft.dark_oak_door": "Кара эмен эшик",
  "block.minecraft.dark_oak_fence": "Кара эмен кашаа",
  "block.minecraft.dark_oak_fence_gate": "Кара эмен дарбаза",
  "block.minecraft.dark_oak_hanging_sign": "Асма кара эмен тактача",
  "block.minecraft.dark_oak_leaves": "Кара эмен жалбырагы",
  "block.minecraft.dark_oak_log": "Кара эмен устуну",
  "block.minecraft.dark_oak_planks": "Кара эмен тактай",
  "block.minecraft.dark_oak_pressure_plate": "Кара эмен басым плитасы",
  "block.minecraft.dark_oak_sapling": "Кара эмен көчөтү",
  "block.minecraft.dark_oak_shelf": "Кара эмен текче",
  "block.minecraft.dark_oak_sign": "Кара эмен тактача",
  "block.minecraft.dark_oak_slab": "Кара эмен плита",
  "block.minecraft.dark_oak_stairs": "Кара эмен тепкич",
  "block.minecraft.dark_oak_trapdoor": "Кара эмен люк",
  "block.minecraft.dark_oak_wall_hanging_sign": "Дубалдагы асма кара эмен тактачасы",
  "block.minecraft.dark_oak_wall_sign": "Дубалдагы кара эмен тактачасы",
  "block.minecraft.dark_oak_wood": "Кара эмен жыгачы",
  "block.minecraft.dark_prismarine": "Кара призмарин",
  "block.minecraft.dark_prismarine_slab": "Кара призмарин плита",
  "block.minecraft.dark_prismarine_stairs": "Кара призмарин тепкич",
  "block.minecraft.daylight_detector": "Күн аныктагычы",
  "block.minecraft.dead_brain_coral": "Өлүк мээ шуру",
  "block.minecraft.dead_brain_coral_block": "Өлүк мээ шуру блогу",
  "block.minecraft.dead_brain_coral_fan": "Өлүк желпингич мээ шуру",
  "block.minecraft.dead_brain_coral_wall_fan": "Дубалдагы өлүк желпингич шурусу",
  "block.minecraft.dead_bubble_coral": "Өлүк көбүкчөлүү шуру",
  "block.minecraft.dead_bubble_coral_block": "Өлүк көбүкчөлүү шуру блогу",
  "block.minecraft.dead_bubble_coral_fan": "Өлүк желпингич көбүкчөлүү шуру",
  "block.minecraft.dead_bubble_coral_wall_fan": "Дубалдагы өлүк желпингич көбүкчөлүү шуру",
  "block.minecraft.dead_bush": "Куураган бадал",
  "block.minecraft.dead_fire_coral": "Өлүк от шуру",
  "block.minecraft.dead_fire_coral_block": "Өлүк от шуру блогу",
  "block.minecraft.dead_fire_coral_fan": "Өлүк желпингич от шуру",
  "block.minecraft.dead_fire_coral_wall_fan": "Дубалдагы өлүк желпингич от шуру",
  "block.minecraft.dead_horn_coral": "Өлүк мүйүз шуру",
  "block.minecraft.dead_horn_coral_block": "Өлүк мүйүз шуру блогу",
  "block.minecraft.dead_horn_coral_fan": "Өлүк желпингич мүйүз шуру",
  "block.minecraft.dead_horn_coral_wall_fan": "Дубалдагы өлүк желпингич мүйүз шуру",
  "block.minecraft.dead_tube_coral": "Өлүк түтүк шуру",
  "block.minecraft.dead_tube_coral_block": "Өлүк түтүк шуру блогу",
  "block.minecraft.dead_tube_coral_fan": "Өлүк желпингич түтүк шуру",
  "block.minecraft.dead_tube_coral_wall_fan": "Дубалдагы өлүк желпингич түтүк шуру",
  "block.minecraft.decorated_pot": "Кооздолгон кумара",
  "block.minecraft.deepslate": "Катмар таш",
  "block.minecraft.deepslate_brick_slab": "Катмар таш кирпич плита",
  "block.minecraft.deepslate_brick_stairs": "Катмар таш кирпич тепкич",
  "block.minecraft.deepslate_brick_wall": "Катмар таш кирпич дубал",
  "block.minecraft.deepslate_bricks": "Катмар таш кирпич",
  "block.minecraft.deepslate_coal_ore": "Көмүр кендүү катмар таш",
  "block.minecraft.deepslate_copper_ore": "Жез кендүү катмар таш",
  "block.minecraft.deepslate_diamond_ore": "Алмаз кендүү катмар таш",
  "block.minecraft.deepslate_emerald_ore": "Зумурут кендүү катмар таш",
  "block.minecraft.deepslate_gold_ore": "Алтын кендүү катмар таш",
  "block.minecraft.deepslate_iron_ore": "Темир кендүү катмар таш",
  "block.minecraft.deepslate_lapis_ore": "Лазурит кендүү катмар таш",
  "block.minecraft.deepslate_redstone_ore": "Редстоун кендүү катмар таш",
  "block.minecraft.deepslate_tile_slab": "Катмар таш плитняк плита",
  "block.minecraft.deepslate_tile_stairs": "Катмар таш плитняк тепкич",
  "block.minecraft.deepslate_tile_wall": "Катмар таш плитняк дубал",
  "block.minecraft.deepslate_tiles": "Катмар таш плитняк",
  "block.minecraft.detector_rail": "Детекторлуу рельс",
  "block.minecraft.diamond_block": "Алмаз блогу",
  "block.minecraft.diamond_ore": "Алмаз кени",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диорит плита",
  "block.minecraft.diorite_stairs": "Диорит тепкич",
  "block.minecraft.diorite_wall": "Диорит дубал",
  "block.minecraft.dirt": "Топурак",
  "block.minecraft.dirt_path": "Сокмок",
  "block.minecraft.dispenser": "Тараткыч",
  "block.minecraft.dragon_egg": "Ажыдаар жумурткасы",
  "block.minecraft.dragon_head": "Ажыдаар башы",
  "block.minecraft.dragon_wall_head": "Дубалдагы ажыдаар башы",
  "block.minecraft.dried_ghast": "Кургак гаст",
  "block.minecraft.dried_kelp_block": "Кургатылган ламинария блогу",
  "block.minecraft.dripstone_block": "Спелеотем",
  "block.minecraft.dropper": "Ыргыткыч",
  "block.minecraft.emerald_block": "Зумурут блогу",
  "block.minecraft.emerald_ore": "Зумурут кени",
  "block.minecraft.enchanting_table": "Сыйкырлоо үстөлү",
  "block.minecraft.end_gateway": "Энд өткөөлү",
  "block.minecraft.end_portal": "Энд порталы",
  "block.minecraft.end_portal_frame": "Энд портал алкагы",
  "block.minecraft.end_rod": "Энд өзөгү",
  "block.minecraft.end_stone": "Энд ташы",
  "block.minecraft.end_stone_brick_slab": "Энд таш плитасы",
  "block.minecraft.end_stone_brick_stairs": "Энд таш кирпич тепкич",
  "block.minecraft.end_stone_brick_wall": "Энд таш кирпич дубалы",
  "block.minecraft.end_stone_bricks": "Энд таш кирпичи",
  "block.minecraft.ender_chest": "Эндер сандык",
  "block.minecraft.exposed_chiseled_copper": "Карарган оюлган жез",
  "block.minecraft.exposed_copper": "Карарган жез",
  "block.minecraft.exposed_copper_bars": "Карарган жез тор",
  "block.minecraft.exposed_copper_bulb": "Карарган жез шам",
  "block.minecraft.exposed_copper_chain": "Карарган жез чынжыр",
  "block.minecraft.exposed_copper_chest": "Карарган жез сандык",
  "block.minecraft.exposed_copper_door": "Карарган жез эшик",
  "block.minecraft.exposed_copper_golem_statue": "Карарган жез големдин айкели",
  "block.minecraft.exposed_copper_grate": "Карарган жез тор",
  "block.minecraft.exposed_copper_lantern": "Карарган жез чырак",
  "block.minecraft.exposed_copper_trapdoor": "Карарган жез эшик",
  "block.minecraft.exposed_cut_copper": "Карарган кесилген жез",
  "block.minecraft.exposed_cut_copper_slab": "Карарган кесилген жез плита",
  "block.minecraft.exposed_cut_copper_stairs": "Карарган кесилген жез тепкич",
  "block.minecraft.exposed_lightning_rod": "Карарган чагылган тоскуч",
  "block.minecraft.farmland": "Айдалган топурак",
  "block.minecraft.fern": "Папоротник",
  "block.minecraft.fire": "От",
  "block.minecraft.fire_coral": "От шуру",
  "block.minecraft.fire_coral_block": "От шуру блогу",
  "block.minecraft.fire_coral_fan": "Желпингич от шуру",
  "block.minecraft.fire_coral_wall_fan": "Дубалдагы желпингич от шуру",
  "block.minecraft.firefly_bush": "Жылтылдактар бадалы",
  "block.minecraft.fletching_table": "Жаачы үстөлү",
  "block.minecraft.flower_pot": "Гүл карапасы",
  "block.minecraft.flowering_azalea": "Гүлдөгөн азалия",
  "block.minecraft.flowering_azalea_leaves": "Гүлдөгөн азалиянын жалбырагы",
  "block.minecraft.frogspawn": "Бака уругу",
  "block.minecraft.frosted_ice": "Эриген муз",
  "block.minecraft.furnace": "Меш",
  "block.minecraft.gilded_blackstone": "Алтын капталган кара таш",
  "block.minecraft.glass": "Айнек",
  "block.minecraft.glass_pane": "Терезе айнеги",
  "block.minecraft.glow_lichen": "Жалтырак эңилчек",
  "block.minecraft.glowstone": "Жарык таш",
  "block.minecraft.gold_block": "Алтын блок",
  "block.minecraft.gold_ore": "Алтын кени",
  "block.minecraft.golden_dandelion": "Алтын каакым",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Гранит плита",
  "block.minecraft.granite_stairs": "Гранит тепкич",
  "block.minecraft.granite_wall": "Гранит дубал",
  "block.minecraft.grass": "Чөп",
  "block.minecraft.grass_block": "Чым",
  "block.minecraft.gravel": "Шагыл",
  "block.minecraft.gray_banner": "Боз желек",
  "block.minecraft.gray_bed": "Боз керебет",
  "block.minecraft.gray_candle": "Боз мом шам",
  "block.minecraft.gray_candle_cake": "Боз мом шамдуу торт",
  "block.minecraft.gray_carpet": "Боз килем",
  "block.minecraft.gray_concrete": "Боз бетон",
  "block.minecraft.gray_concrete_powder": "Боз цемент",
  "block.minecraft.gray_glazed_terracotta": "Боз глазирленген бышкан чопо",
  "block.minecraft.gray_shulker_box": "Боз шалкер кутусу",
  "block.minecraft.gray_stained_glass": "Боз айнек",
  "block.minecraft.gray_stained_glass_pane": "Боз терезе айнеги",
  "block.minecraft.gray_terracotta": "Боз бышкан чопо",
  "block.minecraft.gray_wool": "Боз жүн",
  "block.minecraft.green_banner": "Жашыл желек",
  "block.minecraft.green_bed": "Жашыл керебет",
  "block.minecraft.green_candle": "Жашыл мом шам",
  "block.minecraft.green_candle_cake": "Жашыл мом шамдуу торт",
  "block.minecraft.green_carpet": "Жашыл килем",
  "block.minecraft.green_concrete": "Жашыл бетон",
  "block.minecraft.green_concrete_powder": "Жашыл цемент",
  "block.minecraft.green_glazed_terracotta": "Жашыл глазирленген бышкан чопо",
  "block.minecraft.green_shulker_box": "Жашыл шалкер кутусу",
  "block.minecraft.green_stained_glass": "Жашыл айнек",
  "block.minecraft.green_stained_glass_pane": "Жашыл терезе айнеги",
  "block.minecraft.green_terracotta": "Жашыл бышкан чопо",
  "block.minecraft.green_wool": "Жашыл жүн",
  "block.minecraft.grindstone": "Кайрак таш",
  "block.minecraft.hanging_roots": "Салаң тамырлар",
  "block.minecraft.hay_block": "Боо чөп",
  "block.minecraft.heavy_core": "Чокмордун башы",
  "block.minecraft.heavy_weighted_pressure_plate": "Оор басым плитасы",
  "block.minecraft.honey_block": "Бал блогу",
  "block.minecraft.honeycomb_block": "Аары уяча блогу",
  "block.minecraft.hopper": "Куйгуч",
  "block.minecraft.horn_coral": "Мүйүз шуру",
  "block.minecraft.horn_coral_block": "Мүйүз шуру блогу",
  "block.minecraft.horn_coral_fan": "Желпингич мүйүз шуру",
  "block.minecraft.horn_coral_wall_fan": "Дубалдагы желпингич мүйүз шуру",
  "block.minecraft.ice": "Муз",
  "block.minecraft.infested_chiseled_stone_bricks": "Жуккан оюлган таш кирпич",
  "block.minecraft.infested_cobblestone": "Жуккан сай таш",
  "block.minecraft.infested_cracked_stone_bricks": "Жуккан сынган таш кирпич",
  "block.minecraft.infested_deepslate": "Жуккан катмар таш",
  "block.minecraft.infested_mossy_stone_bricks": "Жуккан эңилчектүү таш кирпич",
  "block.minecraft.infested_stone": "Жуккан таш",
  "block.minecraft.infested_stone_bricks": "Жуккан таш кирпич",
  "block.minecraft.iron_bars": "Темир тор",
  "block.minecraft.iron_block": "Темир блогу",
  "block.minecraft.iron_chain": "Темир чынжыр",
  "block.minecraft.iron_door": "Темир эшик",
  "block.minecraft.iron_ore": "Темир кени",
  "block.minecraft.iron_trapdoor": "Темир люк",
  "block.minecraft.jack_o_lantern": "Джек шамы",
  "block.minecraft.jigsaw": "Пазл блогу",
  "block.minecraft.jukebox": "Ойноткуч",
  "block.minecraft.jungle_button": "Жеңгел баскыч",
  "block.minecraft.jungle_door": "Жеңгел эшик",
  "block.minecraft.jungle_fence": "Жеңгел кашаа",
  "block.minecraft.jungle_fence_gate": "Жеңгел дарбаза",
  "block.minecraft.jungle_hanging_sign": "Асма жеңгел тактачасы",
  "block.minecraft.jungle_leaves": "Жеңгел жалбырагы",
  "block.minecraft.jungle_log": "Жеңгел устуну",
  "block.minecraft.jungle_planks": "Жеңгел тактай",
  "block.minecraft.jungle_pressure_plate": "Жеңгел басым плитасы",
  "block.minecraft.jungle_sapling": "Жеңгел көчөтү",
  "block.minecraft.jungle_shelf": "Тропиктик текче",
  "block.minecraft.jungle_sign": "Жеңгел тактача",
  "block.minecraft.jungle_slab": "Жеңгел плита",
  "block.minecraft.jungle_stairs": "Жеңгел тепкичи",
  "block.minecraft.jungle_trapdoor": "Жеңгел люк",
  "block.minecraft.jungle_wall_hanging_sign": "Дубалдагы асма жеңгел тактачасы",
  "block.minecraft.jungle_wall_sign": "Дубалдагы жеңгел тактачасы",
  "block.minecraft.jungle_wood": "Жеңгел жыгачы",
  "block.minecraft.kelp": "Ламинария",
  "block.minecraft.kelp_plant": "Ламинария сабагы",
  "block.minecraft.ladder": "Шаты",
  "block.minecraft.lantern": "Чырак",
  "block.minecraft.lapis_block": "Лазурит блогу",
  "block.minecraft.lapis_ore": "Лазурит кени",
  "block.minecraft.large_amethyst_bud": "Чоң аметист бүчүрү",
  "block.minecraft.large_fern": "Чоң папоротник",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Лава казаны",
  "block.minecraft.leaf_litter": "Түшкөн жалбырактар",
  "block.minecraft.lectern": "Кафедра",
  "block.minecraft.lever": "Калтек",
  "block.minecraft.light": "Жарык",
  "block.minecraft.light_blue_banner": "Көгүлтүр желек",
  "block.minecraft.light_blue_bed": "Көгүлтүр керебет",
  "block.minecraft.light_blue_candle": "Көгүлтүр мом шам",
  "block.minecraft.light_blue_candle_cake": "Көгүлтүр мом шамдуу торт",
  "block.minecraft.light_blue_carpet": "Көгүлтүр килем",
  "block.minecraft.light_blue_concrete": "Көгүлтүр бетон",
  "block.minecraft.light_blue_concrete_powder": "Көгүлтүр цемент",
  "block.minecraft.light_blue_glazed_terracotta": "Көгүлтүр глазирленген бышкан чопо",
  "block.minecraft.light_blue_shulker_box": "Көгүлтүр шалкер кутусу",
  "block.minecraft.light_blue_stained_glass": "Көгүлтүр айнек",
  "block.minecraft.light_blue_stained_glass_pane": "Көгүлтүр терезе айнеги",
  "block.minecraft.light_blue_terracotta": "Көгүлтүр бышкан чопо",
  "block.minecraft.light_blue_wool": "Көгүлтүр жүн",
  "block.minecraft.light_gray_banner": "Ачык боз желек",
  "block.minecraft.light_gray_bed": "Ачык боз керебет",
  "block.minecraft.light_gray_candle": "Ачык боз мом шам",
  "block.minecraft.light_gray_candle_cake": "Ачык боз мом шамдуу торт",
  "block.minecraft.light_gray_carpet": "Ачык боз килем",
  "block.minecraft.light_gray_concrete": "Ачык боз бетон",
  "block.minecraft.light_gray_concrete_powder": "Ачык боз цемент",
  "block.minecraft.light_gray_glazed_terracotta": "Ачык боз глазирленген бышкан чопо",
  "block.minecraft.light_gray_shulker_box": "Ачык боз шалкер кутусу",
  "block.minecraft.light_gray_stained_glass": "Ачык боз айнек",
  "block.minecraft.light_gray_stained_glass_pane": "Ачык боз терезе айнеги",
  "block.minecraft.light_gray_terracotta": "Ачык боз бышкан чопо",
  "block.minecraft.light_gray_wool": "Ачык боз жүн",
  "block.minecraft.light_weighted_pressure_plate": "Жеңил басым плитасы",
  "block.minecraft.lightning_rod": "Чагылган тоскуч",
  "block.minecraft.lilac": "Сирень",
  "block.minecraft.lily_of_the_valley": "Ландыш",
  "block.minecraft.lily_pad": "Чөмүч баш",
  "block.minecraft.lime_banner": "Лайм желек",
  "block.minecraft.lime_bed": "Лайм керебет",
  "block.minecraft.lime_candle": "Лайм мом шам",
  "block.minecraft.lime_candle_cake": "Лайм мом шамдуу торт",
  "block.minecraft.lime_carpet": "Лайм килем",
  "block.minecraft.lime_concrete": "Лайм бетон",
  "block.minecraft.lime_concrete_powder": "Лайм цемент",
  "block.minecraft.lime_glazed_terracotta": "Лайм глазирленген бышкан чопо",
  "block.minecraft.lime_shulker_box": "Лайм шалкер кутусу",
  "block.minecraft.lime_stained_glass": "Лайм айнек",
  "block.minecraft.lime_stained_glass_pane": "Лайм терезе айнеги",
  "block.minecraft.lime_terracotta": "Лайм бышкан чопо",
  "block.minecraft.lime_wool": "Лайм жүн",
  "block.minecraft.lodestone": "Магнетит",
  "block.minecraft.loom": "Өрмөк",
  "block.minecraft.magenta_banner": "Кара кочкул желек",
  "block.minecraft.magenta_bed": "Кара кочкул керебет",
  "block.minecraft.magenta_candle": "Кара кочкул мом шам",
  "block.minecraft.magenta_candle_cake": "Кара кочкул мом шамдуу торт",
  "block.minecraft.magenta_carpet": "Кара кочкул килем",
  "block.minecraft.magenta_concrete": "Кара кочкул бетон",
  "block.minecraft.magenta_concrete_powder": "Кара кочкул цемент",
  "block.minecraft.magenta_glazed_terracotta": "Кара кочкул глазирленген бышкан чопо",
  "block.minecraft.magenta_shulker_box": "Кара кочкул шалкер кутусу",
  "block.minecraft.magenta_stained_glass": "Кара кочкул айнек",
  "block.minecraft.magenta_stained_glass_pane": "Кара кочкул терезе айнеги",
  "block.minecraft.magenta_terracotta": "Кара кочкул бышкан чопо",
  "block.minecraft.magenta_wool": "Кара кочкул жүн",
  "block.minecraft.magma_block": "Магма блогу",
  "block.minecraft.mangrove_button": "Мангр баскыч",
  "block.minecraft.mangrove_door": "Мангр эшик",
  "block.minecraft.mangrove_fence": "Мангр кашаа",
  "block.minecraft.mangrove_fence_gate": "Мангр дарбазасы",
  "block.minecraft.mangrove_hanging_sign": "Асма мангр тактачасы",
  "block.minecraft.mangrove_leaves": "Мангр жалбырагы",
  "block.minecraft.mangrove_log": "Мангр устуну",
  "block.minecraft.mangrove_planks": "Мангр тактай",
  "block.minecraft.mangrove_pressure_plate": "Мангр басым плитасы",
  "block.minecraft.mangrove_propagule": "Мангр жан бутагы",
  "block.minecraft.mangrove_roots": "Мангр тамыры",
  "block.minecraft.mangrove_shelf": "Мангр текчеси",
  "block.minecraft.mangrove_sign": "Мангр тактача",
  "block.minecraft.mangrove_slab": "Мангр плита",
  "block.minecraft.mangrove_stairs": "Мангр тепкичи",
  "block.minecraft.mangrove_trapdoor": "Мангр люк",
  "block.minecraft.mangrove_wall_hanging_sign": "Дубалдагы асма мангр тактачасы",
  "block.minecraft.mangrove_wall_sign": "Дубалдагы мангр тактачасы",
  "block.minecraft.mangrove_wood": "Мангр жыгачы",
  "block.minecraft.medium_amethyst_bud": "Орточо аметист бүчүрү",
  "block.minecraft.melon": "Дарбыз",
  "block.minecraft.melon_stem": "Дарбыз сабагы",
  "block.minecraft.moss_block": "Баркыт чөп блогу",
  "block.minecraft.moss_carpet": "Баркыт чөп төшөнчү",
  "block.minecraft.mossy_cobblestone": "Эңилчектүү сай таш",
  "block.minecraft.mossy_cobblestone_slab": "Эңилчектүү сай таш плита",
  "block.minecraft.mossy_cobblestone_stairs": "Эңилчектүү сай таш тепкич",
  "block.minecraft.mossy_cobblestone_wall": "Эңилчектүү сай таш дубал",
  "block.minecraft.mossy_stone_brick_slab": "Эңилчектүү таш кирпич плита",
  "block.minecraft.mossy_stone_brick_stairs": "Эңилчектүү таш кирпич тепкич",
  "block.minecraft.mossy_stone_brick_wall": "Эңилчектүү таш кирпич дубал",
  "block.minecraft.mossy_stone_bricks": "Эңилчектүү таш кирпич",
  "block.minecraft.moving_piston": "Жылып жаткан поршень",
  "block.minecraft.mud": "Балчык",
  "block.minecraft.mud_brick_slab": "Саман кирпич плита",
  "block.minecraft.mud_brick_stairs": "Саман кирпич тепкич",
  "block.minecraft.mud_brick_wall": "Саман кирпич дубал",
  "block.minecraft.mud_bricks": "Саман кирпич",
  "block.minecraft.muddy_mangrove_roots": "Балчыктуу мангр тамыры",
  "block.minecraft.mushroom_stem": "Козу карын сабагы",
  "block.minecraft.mycelium": "Мицелий",
  "block.minecraft.nether_brick_fence": "Незер кирпич кашаа",
  "block.minecraft.nether_brick_slab": "Незер кирпич плита",
  "block.minecraft.nether_brick_stairs": "Незер кирпич тепкичи",
  "block.minecraft.nether_brick_wall": "Незер кирпич дубалы",
  "block.minecraft.nether_bricks": "Незер кирпич",
  "block.minecraft.nether_gold_ore": "Незер алтын кени",
  "block.minecraft.nether_portal": "Незер порталы",
  "block.minecraft.nether_quartz_ore": "Незер кварц кени",
  "block.minecraft.nether_sprouts": "Незер тамыры",
  "block.minecraft.nether_wart": "Незер чору",
  "block.minecraft.nether_wart_block": "Незер чор блогу",
  "block.minecraft.netherite_block": "Незерит блогу",
  "block.minecraft.netherrack": "Незер таш",
  "block.minecraft.note_block": "Нота блогу",
  "block.minecraft.oak_button": "Эмен баскыч",
  "block.minecraft.oak_door": "Эмен эшик",
  "block.minecraft.oak_fence": "Эмен кашаа",
  "block.minecraft.oak_fence_gate": "Кара эмен дарбаза",
  "block.minecraft.oak_hanging_sign": "Асма эмен тактача",
  "block.minecraft.oak_leaves": "Эмен жалбырагы",
  "block.minecraft.oak_log": "Эмен устун",
  "block.minecraft.oak_planks": "Эмен тактай",
  "block.minecraft.oak_pressure_plate": "Эмен басым плитасы",
  "block.minecraft.oak_sapling": "Эмен көчөтү",
  "block.minecraft.oak_shelf": "Эмен текче",
  "block.minecraft.oak_sign": "Эмен тактача",
  "block.minecraft.oak_slab": "Эмен плита",
  "block.minecraft.oak_stairs": "Эмен тепкич",
  "block.minecraft.oak_trapdoor": "Эмен люк",
  "block.minecraft.oak_wall_hanging_sign": "Дубалдагы асма эмен тактачасы",
  "block.minecraft.oak_wall_sign": "Дубалдагы эмен тактачасы",
  "block.minecraft.oak_wood": "Эмен жыгачы",
  "block.minecraft.observer": "Байкагыч",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Сары бака шам",
  "block.minecraft.ominous_banner": "Коркунучтуу желек",
  "block.minecraft.open_eyeblossom": "Ачык карек гүл",
  "block.minecraft.orange_banner": "Кызгылт сары желек",
  "block.minecraft.orange_bed": "Кызгылт сары керебет",
  "block.minecraft.orange_candle": "Кызгылт сары мом шам",
  "block.minecraft.orange_candle_cake": "Кызгылт сары мом шам",
  "block.minecraft.orange_carpet": "Кызгылт сары килем",
  "block.minecraft.orange_concrete": "Кызгылт сары бетон",
  "block.minecraft.orange_concrete_powder": "Кызгылт сары цемент",
  "block.minecraft.orange_glazed_terracotta": "Кызгылт сары глазирленген бышкан чопо",
  "block.minecraft.orange_shulker_box": "Кызгылт сары шалкер кутусу",
  "block.minecraft.orange_stained_glass": "Кызгылт сары айнек",
  "block.minecraft.orange_stained_glass_pane": "Кызгылт сары терезе айнеги",
  "block.minecraft.orange_terracotta": "Кызгылт сары бышкан чопо",
  "block.minecraft.orange_tulip": "Кызгылт сары жоогазын",
  "block.minecraft.orange_wool": "Кызгылт сары жүн",
  "block.minecraft.oxeye_daisy": "Ромашка",
  "block.minecraft.oxidized_chiseled_copper": "Дат баскан кесилген жез",
  "block.minecraft.oxidized_copper": "Дат баскан жез",
  "block.minecraft.oxidized_copper_bars": "Дат баскан жез тор",
  "block.minecraft.oxidized_copper_bulb": "Дат баскан жез шам",
  "block.minecraft.oxidized_copper_chain": "Дат баскан жез чынжыр",
  "block.minecraft.oxidized_copper_chest": "Дат баскан жез сандык",
  "block.minecraft.oxidized_copper_door": "Дат баскан жез эшик",
  "block.minecraft.oxidized_copper_golem_statue": "Дат баскан жез големдин айкели",
  "block.minecraft.oxidized_copper_grate": "Дат баскан жез тор",
  "block.minecraft.oxidized_copper_lantern": "Дат баскан жез чырак",
  "block.minecraft.oxidized_copper_trapdoor": "Дат баскан жез люк",
  "block.minecraft.oxidized_cut_copper": "Дат баскан кесилген жез",
  "block.minecraft.oxidized_cut_copper_slab": "Дат баскан кесилген жез плита",
  "block.minecraft.oxidized_cut_copper_stairs": "Дат баскан кесилген жез тепкич",
  "block.minecraft.oxidized_lightning_rod": "Дат баскан чагылган тоскуч",
  "block.minecraft.packed_ice": "Калың муз",
  "block.minecraft.packed_mud": "Саман",
  "block.minecraft.pale_hanging_moss": "Куу салаңдаган баркыт чөп",
  "block.minecraft.pale_moss_block": "Куу баркыт чөп блогу",
  "block.minecraft.pale_moss_carpet": "Куу баркыт чөп килеми",
  "block.minecraft.pale_oak_button": "Куу эмен баскычы",
  "block.minecraft.pale_oak_door": "Куу эмен эшиги",
  "block.minecraft.pale_oak_fence": "Куу эмен кашаа",
  "block.minecraft.pale_oak_fence_gate": "Куу эмен дарбазасы",
  "block.minecraft.pale_oak_hanging_sign": "Асма куу эмен тактача",
  "block.minecraft.pale_oak_leaves": "Куу эмен жалбырагы",
  "block.minecraft.pale_oak_log": "Куу эмен устуну",
  "block.minecraft.pale_oak_planks": "Куу эмен тактайы",
  "block.minecraft.pale_oak_pressure_plate": "Куу эмен басым плитасы",
  "block.minecraft.pale_oak_sapling": "Куу эмен көчөтү",
  "block.minecraft.pale_oak_shelf": "Куу эмен текче",
  "block.minecraft.pale_oak_sign": "Куу эмен тактачасы",
  "block.minecraft.pale_oak_slab": "Куу эмен плита",
  "block.minecraft.pale_oak_stairs": "Куу эмен тепкичи",
  "block.minecraft.pale_oak_trapdoor": "Куу эмен люк",
  "block.minecraft.pale_oak_wall_hanging_sign": "Куу эмен асма тактачасы",
  "block.minecraft.pale_oak_wall_sign": "Дубалдагы куу эмен тактачасы",
  "block.minecraft.pale_oak_wood": "Куу эмен жыгачы",
  "block.minecraft.pearlescent_froglight": "Седеп бака шам",
  "block.minecraft.peony": "Пион",
  "block.minecraft.petrified_oak_slab": "Таштай эмен плита",
  "block.minecraft.piglin_head": "Пиглин башы",
  "block.minecraft.piglin_wall_head": "Дубалдагы пиглин башы",
  "block.minecraft.pink_banner": "Кызгылт желек",
  "block.minecraft.pink_bed": "Кызгылт керебет",
  "block.minecraft.pink_candle": "Кызгылт мом шам",
  "block.minecraft.pink_candle_cake": "Кызгылт мом шамдуу торт",
  "block.minecraft.pink_carpet": "Кызгылт килем",
  "block.minecraft.pink_concrete": "Кызгылт бетон",
  "block.minecraft.pink_concrete_powder": "Кызгылт цемент",
  "block.minecraft.pink_glazed_terracotta": "Кызгылт глазирленген бышкан чопо",
  "block.minecraft.pink_petals": "Кызгылт желекчелер",
  "block.minecraft.pink_shulker_box": "Кызгылт шалкер кутусу",
  "block.minecraft.pink_stained_glass": "Кызгылт айнек",
  "block.minecraft.pink_stained_glass_pane": "Кызгылт терезе айнеги",
  "block.minecraft.pink_terracotta": "Кызгылт бышкан чопо",
  "block.minecraft.pink_tulip": "Кызгылт жоогазын",
  "block.minecraft.pink_wool": "Кызгылт жүн",
  "block.minecraft.piston": "Поршень",
  "block.minecraft.piston_head": "Поршень башы",
  "block.minecraft.pitcher_crop": "Кумган гүл көк тамыры",
  "block.minecraft.pitcher_plant": "Кумган гүл",
  "block.minecraft.player_head": "Оюнчу башы",
  "block.minecraft.player_head.named": "%s башы",
  "block.minecraft.player_wall_head": "Дубалдагы оюнчу башы",
  "block.minecraft.podzol": "Шор топурак",
  "block.minecraft.pointed_dripstone": "Учтуу спелеотем",
  "block.minecraft.polished_andesite": "Жылмаланган андезит",
  "block.minecraft.polished_andesite_slab": "Жылмаланган андезит плита",
  "block.minecraft.polished_andesite_stairs": "Жылмаланган андезит тепкич",
  "block.minecraft.polished_basalt": "Жылмаланган базальт",
  "block.minecraft.polished_blackstone": "Жылмаланган кара таш",
  "block.minecraft.polished_blackstone_brick_slab": "Жылмаланган кара таш кирпич плита",
  "block.minecraft.polished_blackstone_brick_stairs": "Жылмаланган кара таш кирпич тепкич",
  "block.minecraft.polished_blackstone_brick_wall": "Жылмаланган кара таш кирпич дубал",
  "block.minecraft.polished_blackstone_bricks": "Жылмаланган кара таш кирпич",
  "block.minecraft.polished_blackstone_button": "Жылмаланган кара таш баскыч",
  "block.minecraft.polished_blackstone_pressure_plate": "Жылмаланган кара таш басым плитасы",
  "block.minecraft.polished_blackstone_slab": "Жылмаланган кара таш плита",
  "block.minecraft.polished_blackstone_stairs": "Жылмаланган кара таш тепкич",
  "block.minecraft.polished_blackstone_wall": "Жылмаланган кара таш дубал",
  "block.minecraft.polished_deepslate": "Жылмаланган катмар таш",
  "block.minecraft.polished_deepslate_slab": "Жылмаланган катмар таш плита",
  "block.minecraft.polished_deepslate_stairs": "Жылмаланган катмар таш тепкич",
  "block.minecraft.polished_deepslate_wall": "Жылмаланган катмар таш дубал",
  "block.minecraft.polished_diorite": "Жылмаланган диорит",
  "block.minecraft.polished_diorite_slab": "Жылмаланган диорит плита",
  "block.minecraft.polished_diorite_stairs": "Жылмаланган диорит тепкич",
  "block.minecraft.polished_granite": "Жылмаланган гранит",
  "block.minecraft.polished_granite_slab": "Жылмаланган гранит плита",
  "block.minecraft.polished_granite_stairs": "Жылмаланган гранит тепкич",
  "block.minecraft.polished_tuff": "Жылмаланган туф",
  "block.minecraft.polished_tuff_slab": "Жылмаланган туф плита",
  "block.minecraft.polished_tuff_stairs": "Жылмаланган туф тепкич",
  "block.minecraft.polished_tuff_wall": "Жылмаланган туф дубал",
  "block.minecraft.poppy": "Кызгалдак",
  "block.minecraft.potatoes": "Картөшкө",
  "block.minecraft.potted_acacia_sapling": "Карападагы акация көчөтү",
  "block.minecraft.potted_allium": "Карападагы пияз",
  "block.minecraft.potted_azalea_bush": "Карападагы азалия",
  "block.minecraft.potted_azure_bluet": "Карападагы хаустония",
  "block.minecraft.potted_bamboo": "Карападагы бамбук",
  "block.minecraft.potted_birch_sapling": "Карападагы кайың көчөтү",
  "block.minecraft.potted_blue_orchid": "Карападагы көк орхидея",
  "block.minecraft.potted_brown_mushroom": "Карападагы күрөң козу карын",
  "block.minecraft.potted_cactus": "Карападагы кактус",
  "block.minecraft.potted_cherry_sapling": "Карападагы чие көчөтү",
  "block.minecraft.potted_closed_eyeblossom": "Карападагы жабык карек гүл",
  "block.minecraft.potted_cornflower": "Карападагы көк кекире",
  "block.minecraft.potted_crimson_fungus": "Карападагы кырмызы козу карын",
  "block.minecraft.potted_crimson_roots": "Карападагы кырмызы тамырлар",
  "block.minecraft.potted_dandelion": "Карападагы каакым",
  "block.minecraft.potted_dark_oak_sapling": "Карападагы кара эмен көчөтү",
  "block.minecraft.potted_dead_bush": "Карападагы куураган бадал",
  "block.minecraft.potted_fern": "Карападагы папоротник",
  "block.minecraft.potted_flowering_azalea_bush": "Карападагы гүлдөгөн азалия",
  "block.minecraft.potted_golden_dandelion": "Карападагы алтын каакым",
  "block.minecraft.potted_jungle_sapling": "Карападагы жеңгел көчөтү",
  "block.minecraft.potted_lily_of_the_valley": "Карападагы ландыш",
  "block.minecraft.potted_mangrove_propagule": "Карападагы мангр жан бутагы",
  "block.minecraft.potted_oak_sapling": "Карападагы эмен көчөтү",
  "block.minecraft.potted_open_eyeblossom": "Карападагы ачык карек гүл",
  "block.minecraft.potted_orange_tulip": "Карападагы кызгылт сары жоогазын",
  "block.minecraft.potted_oxeye_daisy": "Карападагы ромашка",
  "block.minecraft.potted_pale_oak_sapling": "Карападагы куу эмен көчөтү",
  "block.minecraft.potted_pink_tulip": "Карападагы кызгылт жоогазын",
  "block.minecraft.potted_poppy": "Карападагы кызгалдак",
  "block.minecraft.potted_red_mushroom": "Карападагы кызыл козу карын",
  "block.minecraft.potted_red_tulip": "Карападагы кызыл жоогазын",
  "block.minecraft.potted_spruce_sapling": "Карападагы карагай көчөтү",
  "block.minecraft.potted_torchflower": "Карападагы чырак гүл",
  "block.minecraft.potted_warped_fungus": "Карападагы бүлдүрүлгөн козу карын",
  "block.minecraft.potted_warped_roots": "Карападагы бүлдүрүлгөн тамырлар",
  "block.minecraft.potted_white_tulip": "Карападагы ак жоогазын",
  "block.minecraft.potted_wither_rose": "Карападагы Визер розасы",
  "block.minecraft.powder_snow": "Борпоң кар",
  "block.minecraft.powder_snow_cauldron": "Борпоң кар казаны",
  "block.minecraft.powered_rail": "Кубатталган рельс",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Призмарин кирпич плита",
  "block.minecraft.prismarine_brick_stairs": "Призмарин кирпич тепкич",
  "block.minecraft.prismarine_bricks": "Призмарин кирпич",
  "block.minecraft.prismarine_slab": "Призмарин плита",
  "block.minecraft.prismarine_stairs": "Призмарин тепкич",
  "block.minecraft.prismarine_wall": "Призмарин дубал",
  "block.minecraft.pumpkin": "Ашкабак",
  "block.minecraft.pumpkin_stem": "Ашкабак сабагы",
  "block.minecraft.purple_banner": "Кызгылт көк желек",
  "block.minecraft.purple_bed": "Кызгылт көк керебет",
  "block.minecraft.purple_candle": "Кызгылт көк мом шам",
  "block.minecraft.purple_candle_cake": "Кызгылт көк мом шамдуу торт",
  "block.minecraft.purple_carpet": "Кызгылт көк килем",
  "block.minecraft.purple_concrete": "Кызгылт көк бетон",
  "block.minecraft.purple_concrete_powder": "Кызгылт көк цемент",
  "block.minecraft.purple_glazed_terracotta": "Кызгылт көк глазирленген бышкан чопо",
  "block.minecraft.purple_shulker_box": "Кызгылт көк шалкер кутусу",
  "block.minecraft.purple_stained_glass": "Кызгылт көк айнек",
  "block.minecraft.purple_stained_glass_pane": "Кызгылт көк терезе айнеги",
  "block.minecraft.purple_terracotta": "Кызгылт көк бышкан чопо",
  "block.minecraft.purple_wool": "Кызгылт көк жүн",
  "block.minecraft.purpur_block": "Пурпур",
  "block.minecraft.purpur_pillar": "Пурпур түркүк",
  "block.minecraft.purpur_slab": "Пурпур плита",
  "block.minecraft.purpur_stairs": "Пурпур тепкич",
  "block.minecraft.quartz_block": "Кварц блогу",
  "block.minecraft.quartz_bricks": "Кварц кирпич",
  "block.minecraft.quartz_pillar": "Кварц түркүк",
  "block.minecraft.quartz_slab": "Кварц плита",
  "block.minecraft.quartz_stairs": "Кварц тепкич",
  "block.minecraft.rail": "Рельс",
  "block.minecraft.raw_copper_block": "Чийки жез блогу",
  "block.minecraft.raw_gold_block": "Чийки алтын блогу",
  "block.minecraft.raw_iron_block": "Чийки темир блогу",
  "block.minecraft.red_banner": "Кызыл желек",
  "block.minecraft.red_bed": "Кызыл керебет",
  "block.minecraft.red_candle": "Кызыл мом шам",
  "block.minecraft.red_candle_cake": "Кызыл мом шамдуу торт",
  "block.minecraft.red_carpet": "Кызыл килем",
  "block.minecraft.red_concrete": "Кызыл бетон",
  "block.minecraft.red_concrete_powder": "Кызыл цемент",
  "block.minecraft.red_glazed_terracotta": "Кызыл глазирленген бышкан чопо",
  "block.minecraft.red_mushroom": "Кызыл козу карын",
  "block.minecraft.red_mushroom_block": "Кызыл козу карын блогу",
  "block.minecraft.red_nether_brick_slab": "Кызыл незер кирпич плитасы",
  "block.minecraft.red_nether_brick_stairs": "Кызыл незер кирпич тепкичи",
  "block.minecraft.red_nether_brick_wall": "Кызыл незер кирпич дубалы",
  "block.minecraft.red_nether_bricks": "Кызыл незер кирпич",
  "block.minecraft.red_sand": "Кызыл кум",
  "block.minecraft.red_sandstone": "Кызыл кум таш",
  "block.minecraft.red_sandstone_slab": "Кызыл кум таш плита",
  "block.minecraft.red_sandstone_stairs": "Кызыл кум таш тепкич",
  "block.minecraft.red_sandstone_wall": "Кызыл кум таш дубал",
  "block.minecraft.red_shulker_box": "Кызыл шалкер кутусу",
  "block.minecraft.red_stained_glass": "Кызыл айнек",
  "block.minecraft.red_stained_glass_pane": "Кызыл терезе айнеги",
  "block.minecraft.red_terracotta": "Кызыл бышкан чопо",
  "block.minecraft.red_tulip": "Кызыл жоогазын",
  "block.minecraft.red_wool": "Кызыл жүн",
  "block.minecraft.redstone_block": "Редстоун блогу",
  "block.minecraft.redstone_lamp": "Редстоун шамы",
  "block.minecraft.redstone_ore": "Редстоун кени",
  "block.minecraft.redstone_torch": "Редстоун шамана",
  "block.minecraft.redstone_wall_torch": "Дубалдагы редстоун шаманасы",
  "block.minecraft.redstone_wire": "Редстоун зымы",
  "block.minecraft.reinforced_deepslate": "Бек катмар таш",
  "block.minecraft.repeater": "Редстоун кайталагыч",
  "block.minecraft.repeating_command_block": "Кайталачу команда блогу",
  "block.minecraft.resin_block": "Чайыр блок",
  "block.minecraft.resin_brick_slab": "Чайыр кирпич плита",
  "block.minecraft.resin_brick_stairs": "Чайыр кирпич тепкичи",
  "block.minecraft.resin_brick_wall": "Чайыр кирпич дубал",
  "block.minecraft.resin_bricks": "Чайыр кирпич",
  "block.minecraft.resin_clump": "Уюуган чайыр",
  "block.minecraft.respawn_anchor": "Тирилүү якору",
  "block.minecraft.rooted_dirt": "Тамырлуу топурак",
  "block.minecraft.rose_bush": "Роза бадалы",
  "block.minecraft.sand": "Кум",
  "block.minecraft.sandstone": "Кум таш",
  "block.minecraft.sandstone_slab": "Кум таш плита",
  "block.minecraft.sandstone_stairs": "Кум таш тепкич",
  "block.minecraft.sandstone_wall": "Кум таш дубал",
  "block.minecraft.scaffolding": "Курулуш шаты",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк жайгыч",
  "block.minecraft.sculk_sensor": "Скалк сенсору",
  "block.minecraft.sculk_shrieker": "Скалк чырылдагыч",
  "block.minecraft.sculk_vein": "Скалк тамыры",
  "block.minecraft.sea_lantern": "Деңиз шамы",
  "block.minecraft.sea_pickle": "Деңиз бадыраңы",
  "block.minecraft.seagrass": "Деңиз чөбү",
  "block.minecraft.set_spawn": "Тирилүү орду орнотулду",
  "block.minecraft.short_dry_grass": "Куураган кыска чөп",
  "block.minecraft.short_grass": "Кыска чөп",
  "block.minecraft.shroomlight": "Козу карын жарык",
  "block.minecraft.shulker_box": "Шалкер кутусу",
  "block.minecraft.skeleton_skull": "Баш сөөк",
  "block.minecraft.skeleton_wall_skull": "Дубалдагы баш сөөк",
  "block.minecraft.slime_block": "Былжыр блогу",
  "block.minecraft.small_amethyst_bud": "Кичи аметист бүчүрү",
  "block.minecraft.small_dripleaf": "Кичи тамчы жалбырак",
  "block.minecraft.smithing_table": "Темирчи үстөлү",
  "block.minecraft.smoker": "Ыштагыч",
  "block.minecraft.smooth_basalt": "Жылмакай базальт",
  "block.minecraft.smooth_quartz": "Жылмакай кварц блогу",
  "block.minecraft.smooth_quartz_slab": "Жылмакай кварц плита",
  "block.minecraft.smooth_quartz_stairs": "Жылмакай кварц тепкич",
  "block.minecraft.smooth_red_sandstone": "Жылмакай кызыл кум таш",
  "block.minecraft.smooth_red_sandstone_slab": "Жылмакай кызыл кум таш плита",
  "block.minecraft.smooth_red_sandstone_stairs": "Жылмакай кызыл кум таш тепкич",
  "block.minecraft.smooth_sandstone": "Жылмакай кум таш",
  "block.minecraft.smooth_sandstone_slab": "Жылмакай кум таш плита",
  "block.minecraft.smooth_sandstone_stairs": "Жылмакай кум таш тепкич",
  "block.minecraft.smooth_stone": "Жылмакай таш",
  "block.minecraft.smooth_stone_slab": "Жылмакай таш плита",
  "block.minecraft.sniffer_egg": "Жыттоочу жумурткасы",
  "block.minecraft.snow": "Кар",
  "block.minecraft.snow_block": "Кар блогу",
  "block.minecraft.soul_campfire": "Жан очогу",
  "block.minecraft.soul_fire": "Жан оту",
  "block.minecraft.soul_lantern": "Жан чырагы",
  "block.minecraft.soul_sand": "Жан кум",
  "block.minecraft.soul_soil": "Жан топурагы",
  "block.minecraft.soul_torch": "Жан шамана",
  "block.minecraft.soul_wall_torch": "Дубалдагы жан шамана",
  "block.minecraft.spawn.not_valid": "Сизде керебет, кубатталган тирилүү якору жок же анын баары жеткиликтүү эмес",
  "block.minecraft.spawner": "Мокочо жараткыч",
  "block.minecraft.spawner.desc1": "Жаратуу жумуртка менен аракеттешүү:",
  "block.minecraft.spawner.desc2": "Моб түрүн орнотот",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Спора гүлү",
  "block.minecraft.spruce_button": "Карагай баскыч",
  "block.minecraft.spruce_door": "Карагай эшик",
  "block.minecraft.spruce_fence": "Карагай кашаа",
  "block.minecraft.spruce_fence_gate": "Карагай дарбаза",
  "block.minecraft.spruce_hanging_sign": "Асма карагай тактача",
  "block.minecraft.spruce_leaves": "Карагай ийне жалбырагы",
  "block.minecraft.spruce_log": "Карагай устуну",
  "block.minecraft.spruce_planks": "Карагай тактай",
  "block.minecraft.spruce_pressure_plate": "Карагай басым плитасы",
  "block.minecraft.spruce_sapling": "Карагай көчөтү",
  "block.minecraft.spruce_shelf": "Карагай текче",
  "block.minecraft.spruce_sign": "Карагай тактача",
  "block.minecraft.spruce_slab": "Карагай плита",
  "block.minecraft.spruce_stairs": "Карагай тепкич",
  "block.minecraft.spruce_trapdoor": "Карагай люк",
  "block.minecraft.spruce_wall_hanging_sign": "Дубалдагы асма карагай тактачасы",
  "block.minecraft.spruce_wall_sign": "Дубалдагы карагай тактачасы",
  "block.minecraft.spruce_wood": "Карагай жыгачы",
  "block.minecraft.sticky_piston": "Жабышчак поршень",
  "block.minecraft.stone": "Таш",
  "block.minecraft.stone_brick_slab": "Таш кирпич плита",
  "block.minecraft.stone_brick_stairs": "Таш кирпич тепкичи",
  "block.minecraft.stone_brick_wall": "Таш кирпич дубал",
  "block.minecraft.stone_bricks": "Таш кирпич",
  "block.minecraft.stone_button": "Таш баскыч",
  "block.minecraft.stone_pressure_plate": "Таш басым плитасы",
  "block.minecraft.stone_slab": "Таш плита",
  "block.minecraft.stone_stairs": "Таш тепкич",
  "block.minecraft.stonecutter": "Таш кескич",
  "block.minecraft.stripped_acacia_log": "Жонулган акация устуну",
  "block.minecraft.stripped_acacia_wood": "Жонулган акация жыгачы",
  "block.minecraft.stripped_bamboo_block": "Жонулган бамбук блогу",
  "block.minecraft.stripped_birch_log": "Жонулган кайың устуну",
  "block.minecraft.stripped_birch_wood": "Жонулган кайың жыгачы",
  "block.minecraft.stripped_cherry_log": "Жонулган чие устуну",
  "block.minecraft.stripped_cherry_wood": "Жонулган чие жыгачы",
  "block.minecraft.stripped_crimson_hyphae": "Жонулган кырмызы гифа",
  "block.minecraft.stripped_crimson_stem": "Жонулган кырмызы сабак",
  "block.minecraft.stripped_dark_oak_log": "Жонулган кара эмен устуну",
  "block.minecraft.stripped_dark_oak_wood": "Жонулган кара эмен жыгачы",
  "block.minecraft.stripped_jungle_log": "Жонулган жеңгел устуну",
  "block.minecraft.stripped_jungle_wood": "Жонулган жеңгел жыгачы",
  "block.minecraft.stripped_mangrove_log": "Жонулган мангр устуну",
  "block.minecraft.stripped_mangrove_wood": "Жонулган мангр жыгачы",
  "block.minecraft.stripped_oak_log": "Жонулган эмен устуну",
  "block.minecraft.stripped_oak_wood": "Жонулган эмен жыгачы",
  "block.minecraft.stripped_pale_oak_log": "Жонулган куу эмен устуну",
  "block.minecraft.stripped_pale_oak_wood": "Жонулган куу эмен жыгачы",
  "block.minecraft.stripped_spruce_log": "Жонулган карагай устуну",
  "block.minecraft.stripped_spruce_wood": "Жонулган карагай жыгачы",
  "block.minecraft.stripped_warped_hyphae": "Жонулган бүлдүрүлгөн гифа",
  "block.minecraft.stripped_warped_stem": "Жонулган бүлдүрүлгөн сабак",
  "block.minecraft.structure_block": "Курулуш блогу",
  "block.minecraft.structure_void": "Бош блок",
  "block.minecraft.sugar_cane": "Кант камышы",
  "block.minecraft.sunflower": "Күн карама",
  "block.minecraft.suspicious_gravel": "Кызык шагыл",
  "block.minecraft.suspicious_sand": "Кызык кум",
  "block.minecraft.sweet_berry_bush": "Таттуу мөмө бадалы",
  "block.minecraft.tall_dry_grass": "Куураган узун чөп",
  "block.minecraft.tall_grass": "Узун чөп",
  "block.minecraft.tall_seagrass": "Узун деңиз чөбү",
  "block.minecraft.target": "Бута",
  "block.minecraft.terracotta": "Бышкан чопо",
  "block.minecraft.test_block": "Тест-блок",
  "block.minecraft.test_instance_block": "Үлгүнүн тест-блогу",
  "block.minecraft.tinted_glass": "Күңүрт айнек",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "Динамит жарылуулары өчүрүлгөн",
  "block.minecraft.torch": "Шамана",
  "block.minecraft.torchflower": "Чырак гүл",
  "block.minecraft.torchflower_crop": "Чырак гүл көк тамыры",
  "block.minecraft.trapped_chest": "Тузак сандык",
  "block.minecraft.trial_spawner": "Сыноо жараткычы",
  "block.minecraft.tripwire": "Керме",
  "block.minecraft.tripwire_hook": "Илгич",
  "block.minecraft.tube_coral": "Түтүк шуру",
  "block.minecraft.tube_coral_block": "Түтүк шуру блогу",
  "block.minecraft.tube_coral_fan": "Желпингич түтүк шуру",
  "block.minecraft.tube_coral_wall_fan": "Дубалдагы желпингич түтүк шуру",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туф кирпич плита",
  "block.minecraft.tuff_brick_stairs": "Туф кирпич тепкич",
  "block.minecraft.tuff_brick_wall": "Туф кирпич дубал",
  "block.minecraft.tuff_bricks": "Туф кирпич",
  "block.minecraft.tuff_slab": "Туф плита",
  "block.minecraft.tuff_stairs": "Туф тепкич",
  "block.minecraft.tuff_wall": "Туф дубал",
  "block.minecraft.turtle_egg": "Таш бака жумурткасы",
  "block.minecraft.twisting_vines": "Чырмалгыч лиана",
  "block.minecraft.twisting_vines_plant": "Чырмалгыч лиана сабагы",
  "block.minecraft.vault": "Сактагыч",
  "block.minecraft.verdant_froglight": "Зумурут бака шам",
  "block.minecraft.vine": "Лиана",
  "block.minecraft.void_air": "Вакуум",
  "block.minecraft.wall_torch": "Дубалдагы шамана",
  "block.minecraft.warped_button": "Бүлдүрүлгөн баскыч",
  "block.minecraft.warped_door": "Бүлдүрүлгөн эшик",
  "block.minecraft.warped_fence": "Бүлдүрүлгөн кашаа",
  "block.minecraft.warped_fence_gate": "Бүлдүрүлгөн дарбаза",
  "block.minecraft.warped_fungus": "Бүлдүрүлгөн козу карын",
  "block.minecraft.warped_hanging_sign": "Асма бүлдүрүлгөн тактача",
  "block.minecraft.warped_hyphae": "Бүлдүрүлгөн гифа",
  "block.minecraft.warped_nylium": "Бүлдүрүлгөн нилий",
  "block.minecraft.warped_planks": "Бүлдүрүлгөн тактай",
  "block.minecraft.warped_pressure_plate": "Бүлдүрүлгөн басым плитасы",
  "block.minecraft.warped_roots": "Бүлдүрүлгөн тамырлар",
  "block.minecraft.warped_shelf": "Бүлдүрүлгөн текче",
  "block.minecraft.warped_sign": "Бүлдүрүлгөн тактача",
  "block.minecraft.warped_slab": "Бүлдүрүлгөн плита",
  "block.minecraft.warped_stairs": "Бүлдүрүлгөн тепкич",
  "block.minecraft.warped_stem": "Бүлдүрүлгөн сабак",
  "block.minecraft.warped_trapdoor": "Бүлдүрүлгөн люк",
  "block.minecraft.warped_wall_hanging_sign": "Дубалдагы асма бүлдүрүлгөн тактача",
  "block.minecraft.warped_wall_sign": "Асма бүлдүрүлгөн тактача",
  "block.minecraft.warped_wart_block": "Бүлдүрүлгөн чор блогу",
  "block.minecraft.water": "Суу",
  "block.minecraft.water_cauldron": "Суу казан",
  "block.minecraft.waxed_chiseled_copper": "Момдолгон оюлган жез",
  "block.minecraft.waxed_copper_bars": "Момдолгон жез тор",
  "block.minecraft.waxed_copper_block": "Момдолгон жез блогу",
  "block.minecraft.waxed_copper_bulb": "Момдолгон жез шам",
  "block.minecraft.waxed_copper_chain": "Момдолгон жез чынжыр",
  "block.minecraft.waxed_copper_chest": "Момдолгон жез сандык",
  "block.minecraft.waxed_copper_door": "Момдолгон жез эшик",
  "block.minecraft.waxed_copper_golem_statue": "Момдолгон жез големдин айкели",
  "block.minecraft.waxed_copper_grate": "Момдолгон жез тор",
  "block.minecraft.waxed_copper_lantern": "Момдолгон жез чырак",
  "block.minecraft.waxed_copper_trapdoor": "Момдолгон жез люк",
  "block.minecraft.waxed_cut_copper": "Момдолгон кесилген жез",
  "block.minecraft.waxed_cut_copper_slab": "Момдолгон кесилген жез плита",
  "block.minecraft.waxed_cut_copper_stairs": "Момдолгон кесилген жез тепкич",
  "block.minecraft.waxed_exposed_chiseled_copper": "Момдолгон карарган кесилген жез",
  "block.minecraft.waxed_exposed_copper": "Момдолгон карарган жез",
  "block.minecraft.waxed_exposed_copper_bars": "Момдолгон карарган жез тор",
  "block.minecraft.waxed_exposed_copper_bulb": "Момдолгон карарган жез шам",
  "block.minecraft.waxed_exposed_copper_chain": "Момдолгон карарган жез чынжыр",
  "block.minecraft.waxed_exposed_copper_chest": "Момдолгон карарган жез сандык",
  "block.minecraft.waxed_exposed_copper_door": "Момдолгон карарган жез эшик",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Момдолгон карарган жез големдин айкели",
  "block.minecraft.waxed_exposed_copper_grate": "Момдолгон карарган жез тор",
  "block.minecraft.waxed_exposed_copper_lantern": "Момдолгон карарган жез чырак",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Момдолгон карарган жез люк",
  "block.minecraft.waxed_exposed_cut_copper": "Момдолгон карарган кесилген жез",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Момдолгон карарган кесилген жез плита",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Момдолгон карарган кесилген жез тепкич",
  "block.minecraft.waxed_exposed_lightning_rod": "Момдолгон карарган чагылган тоскуч",
  "block.minecraft.waxed_lightning_rod": "Момдолгон чагылган тоскуч",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Момдолгон дат баскан оюлган жез",
  "block.minecraft.waxed_oxidized_copper": "Момдолгон дат баскан жез",
  "block.minecraft.waxed_oxidized_copper_bars": "Момдолгон дат баскан жез тор",
  "block.minecraft.waxed_oxidized_copper_bulb": "Момдолгон дат баскан жез шам",
  "block.minecraft.waxed_oxidized_copper_chain": "Момдолгон дат баскан жез чынжыр",
  "block.minecraft.waxed_oxidized_copper_chest": "Момдолгон дат баскан жез сандык",
  "block.minecraft.waxed_oxidized_copper_door": "Момдолгон дат баскан жез эшик",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Момдолгон дат баскан жез големдин айкели",
  "block.minecraft.waxed_oxidized_copper_grate": "Момдолгон дат баскан жез тор",
  "block.minecraft.waxed_oxidized_copper_lantern": "Момдолгон дат баскан жез чырак",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Момдолгон дат баскан жез люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Момдолгон дат баскан кесилген жез",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Момдолгон дат баскан кесилген жез плита",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Момдолгон дат баскан кесилген жез тепкич",
  "block.minecraft.waxed_oxidized_lightning_rod": "Момдолгон дат баскан чагылган тоскуч",
  "block.minecraft.waxed_weathered_chiseled_copper": "Момдолгон көгөргөн оюлган жез",
  "block.minecraft.waxed_weathered_copper": "Момдолгон көгөргөн жез",
  "block.minecraft.waxed_weathered_copper_bars": "Момдолгон көгөргөн жез тор",
  "block.minecraft.waxed_weathered_copper_bulb": "Момдолгон көгөргөн жез шам",
  "block.minecraft.waxed_weathered_copper_chain": "Момдолгон көгөргөн жез чынжыр",
  "block.minecraft.waxed_weathered_copper_chest": "Момдолгон көгөргөн жез сандык",
  "block.minecraft.waxed_weathered_copper_door": "Момдолгон көгөргөн жез эшик",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Момдолгон көгөргөн жез големдин айкели",
  "block.minecraft.waxed_weathered_copper_grate": "Момдолгон көгөргөн жез тор",
  "block.minecraft.waxed_weathered_copper_lantern": "Момдолгон көгөргөн жез чырак",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Момдолгон көгөргөн жез люк",
  "block.minecraft.waxed_weathered_cut_copper": "Момдолгон көгөргөн кесилген жез",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Момдолгон көгөргөн кесилген жез плита",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Момдолгон көгөргөн кесилген жез тепкич",
  "block.minecraft.waxed_weathered_lightning_rod": "Момдолгон көгөргөн чагылган тоскуч",
  "block.minecraft.weathered_chiseled_copper": "Момдолгон оюлган жез",
  "block.minecraft.weathered_copper": "Көгөргөн жез",
  "block.minecraft.weathered_copper_bars": "Көгөргөн жез тор",
  "block.minecraft.weathered_copper_bulb": "Көгөргөн жез шам",
  "block.minecraft.weathered_copper_chain": "Көгөргөн жез чынжыр",
  "block.minecraft.weathered_copper_chest": "Көгөргөн жез сандык",
  "block.minecraft.weathered_copper_door": "Көгөргөн жез эшик",
  "block.minecraft.weathered_copper_golem_statue": "Көгөргөн жез големдин айкели",
  "block.minecraft.weathered_copper_grate": "Көгөргөн жез тор",
  "block.minecraft.weathered_copper_lantern": "Көгөргөн жез чырак",
  "block.minecraft.weathered_copper_trapdoor": "Көгөргөн жез люк",
  "block.minecraft.weathered_cut_copper": "Көгөргөн кесилген жез",
  "block.minecraft.weathered_cut_copper_slab": "Көгөргөн кесилген жез плита",
  "block.minecraft.weathered_cut_copper_stairs": "Көгөргөн кесилген жез тепкич",
  "block.minecraft.weathered_lightning_rod": "Көгөргөн чагылган тоскуч",
  "block.minecraft.weeping_vines": "Ыйлаак лиана",
  "block.minecraft.weeping_vines_plant": "Ыйлаак лиана сабагы",
  "block.minecraft.wet_sponge": "Ным губка",
  "block.minecraft.wheat": "Буудай көк тамыры",
  "block.minecraft.white_banner": "Ак желек",
  "block.minecraft.white_bed": "Ак керебет",
  "block.minecraft.white_candle": "Ак мом шам",
  "block.minecraft.white_candle_cake": "Ак мом шамдуу торт",
  "block.minecraft.white_carpet": "Ак килем",
  "block.minecraft.white_concrete": "Ак бетон",
  "block.minecraft.white_concrete_powder": "Ак цемент",
  "block.minecraft.white_glazed_terracotta": "Ак глазирленген бышкан чопо",
  "block.minecraft.white_shulker_box": "Ак шалкер кутусу",
  "block.minecraft.white_stained_glass": "Ак айнек",
  "block.minecraft.white_stained_glass_pane": "Ак терезе айнеги",
  "block.minecraft.white_terracotta": "Ак бышкан чопо",
  "block.minecraft.white_tulip": "Ак жоогазын",
  "block.minecraft.white_wool": "Ак жүн",
  "block.minecraft.wildflowers": "Талаа гүлдөрү",
  "block.minecraft.wither_rose": "Визер розасы",
  "block.minecraft.wither_skeleton_skull": "Визер сүлдөр баш сөөгү",
  "block.minecraft.wither_skeleton_wall_skull": "Дубалдагы визер сүлдөр баш сөөгү",
  "block.minecraft.yellow_banner": "Сары желек",
  "block.minecraft.yellow_bed": "Сары керебет",
  "block.minecraft.yellow_candle": "Сары мом шам",
  "block.minecraft.yellow_candle_cake": "Сары мом шамдуу торт",
  "block.minecraft.yellow_carpet": "Сары килем",
  "block.minecraft.yellow_concrete": "Сары бетон",
  "block.minecraft.yellow_concrete_powder": "Сары цемент",
  "block.minecraft.yellow_glazed_terracotta": "Сары глазирленген бышкан чопо",
  "block.minecraft.yellow_shulker_box": "Сары шалкер кутусу",
  "block.minecraft.yellow_stained_glass": "Сары айнек",
  "block.minecraft.yellow_stained_glass_pane": "Сары терезе айнеги",
  "block.minecraft.yellow_terracotta": "Сары бышкан чопо",
  "block.minecraft.yellow_wool": "Сары жүн",
  "block.minecraft.zombie_head": "Зомби башы",
  "block.minecraft.zombie_wall_head": "Дубалдагы зомби башы",
  "item.minecraft.acacia_boat": "Акация кайык",
  "item.minecraft.acacia_chest_boat": "Сандыктуу акация кайык",
  "item.minecraft.allay_spawn_egg": "Тымпый жаратуу жумурткасы",
  "item.minecraft.amethyst_shard": "Аметист сыныгы",
  "item.minecraft.angler_pottery_shard": "«Балыкчы» кумара сыныгы",
  "item.minecraft.angler_pottery_sherd": "«Балыкчы» кумара сыныгы",
  "item.minecraft.apple": "Алма",
  "item.minecraft.archer_pottery_shard": "«Жаачы» кумара сыныгы",
  "item.minecraft.archer_pottery_sherd": "«Жаачы» кумара сыныгы",
  "item.minecraft.armadillo_scute": "Чопкутчандын калканчасы",
  "item.minecraft.armadillo_spawn_egg": "Чопкутчан жаратуу жумурткасы",
  "item.minecraft.armor_stand": "Соот илгич",
  "item.minecraft.arms_up_pottery_shard": "«Кол көтөр» кумара сыныгы",
  "item.minecraft.arms_up_pottery_sherd": "«Кол көтөр» кумара сыныгы",
  "item.minecraft.arrow": "Жебе",
  "item.minecraft.axolotl_bucket": "Чакадагы аксолотль",
  "item.minecraft.axolotl_spawn_egg": "Аксолотль жаратуу жумурткасы",
  "item.minecraft.baked_potato": "Бышкан картөшкө",
  "item.minecraft.bamboo_chest_raft": "Сандыктуу бамбук сал",
  "item.minecraft.bamboo_raft": "Бамбук салы",
  "item.minecraft.bat_spawn_egg": "Жарганат жаратуу жумурткасы",
  "item.minecraft.bee_spawn_egg": "Аары жаратуу жумурткасы",
  "item.minecraft.beef": "Чийки уй эти",
  "item.minecraft.beetroot": "Кызылча",
  "item.minecraft.beetroot_seeds": "Кызылча үрөнү",
  "item.minecraft.beetroot_soup": "Кызылча сорпо",
  "item.minecraft.birch_boat": "Кайың кайык",
  "item.minecraft.birch_chest_boat": "Сандыктуу кайың кайык",
  "item.minecraft.black_bundle": "Кара кап",
  "item.minecraft.black_dye": "Кара боёгуч",
  "item.minecraft.black_harness": "Кара гаст жабдыгы",
  "item.minecraft.blade_pottery_shard": "«Кылыч» кумара сыныгы",
  "item.minecraft.blade_pottery_sherd": "«Кылыч» кумара сыныгы",
  "item.minecraft.blaze_powder": "Жалын күкүмү",
  "item.minecraft.blaze_rod": "Жалын өзөгү",
  "item.minecraft.blaze_spawn_egg": "Жалын жаратуу жумурткасы",
  "item.minecraft.blue_bundle": "Көк кап",
  "item.minecraft.blue_dye": "Көк боёгуч",
  "item.minecraft.blue_egg": "Көк жумуртка",
  "item.minecraft.blue_harness": "Көк гаст жабдыгы",
  "item.minecraft.bogged_spawn_egg": "Баткын жаратуу жумурткасы",
  "item.minecraft.bolt_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "«Ок» оюусу",
  "item.minecraft.bone": "Сөөк",
  "item.minecraft.bone_meal": "Сөөк уну",
  "item.minecraft.book": "Китеп",
  "item.minecraft.bordure_indented_banner_pattern": "«Ийри жээк» желек оймосу",
  "item.minecraft.bow": "Жаа",
  "item.minecraft.bowl": "Табак",
  "item.minecraft.bread": "Нан",
  "item.minecraft.breeze_rod": "Куюн өзөгү",
  "item.minecraft.breeze_spawn_egg": "Куюн жаратуу жумурткасы",
  "item.minecraft.brewer_pottery_shard": "«Демдөөчү» кумара сыныгы",
  "item.minecraft.brewer_pottery_sherd": "«Демдөөчү» кумара сыныгы",
  "item.minecraft.brewing_stand": "Кайнаткыч",
  "item.minecraft.brick": "Кирпич",
  "item.minecraft.brown_bundle": "Күрөң кап",
  "item.minecraft.brown_dye": "Күрөң боёгуч",
  "item.minecraft.brown_egg": "Күрөң жумуртка",
  "item.minecraft.brown_harness": "Күрөң гаст жабдыгы",
  "item.minecraft.brush": "Кыл калем",
  "item.minecraft.bucket": "Чака",
  "item.minecraft.bundle": "Кап",
  "item.minecraft.bundle.empty": "Бош",
  "item.minecraft.bundle.empty.description": "Бир топ буюм батырат",
  "item.minecraft.bundle.full": "Толгон",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "«Жалын» кумара сыныгы",
  "item.minecraft.burn_pottery_sherd": "«Жалын» кумара сыныгы",
  "item.minecraft.camel_husk_spawn_egg": "Төө өлүк жаратуу жумурткасы",
  "item.minecraft.camel_spawn_egg": "Төө жаратуу жумурткасы",
  "item.minecraft.carrot": "Сабиз",
  "item.minecraft.carrot_on_a_stick": "Кайырмактагы сабиз",
  "item.minecraft.cat_spawn_egg": "Мышык жаратуу жумурткасы",
  "item.minecraft.cauldron": "Казан",
  "item.minecraft.cave_spider_spawn_egg": "Үңкүр жөргөмүшү жаратуу жумурткасы",
  "item.minecraft.chainmail_boots": "Тор өтүк",
  "item.minecraft.chainmail_chestplate": "Тор соот",
  "item.minecraft.chainmail_helmet": "Тор туулга",
  "item.minecraft.chainmail_leggings": "Тор шым",
  "item.minecraft.charcoal": "Жыгач көмүр",
  "item.minecraft.cherry_boat": "Чие кайык",
  "item.minecraft.cherry_chest_boat": "Сандыктуу чие кайык",
  "item.minecraft.chest_minecart": "Сандык бар вагончо",
  "item.minecraft.chicken": "Чийки тоок эти",
  "item.minecraft.chicken_spawn_egg": "Тоок жаратуу жумурткасы",
  "item.minecraft.chorus_fruit": "Корус жемиши",
  "item.minecraft.clay_ball": "Кесек чопо",
  "item.minecraft.clock": "Саат",
  "item.minecraft.coal": "Көмүр",
  "item.minecraft.coast_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.coast_armor_trim_smithing_template.new": "«Жээк» оюусу",
  "item.minecraft.cocoa_beans": "Какао буурчактары",
  "item.minecraft.cod": "Чийки треска",
  "item.minecraft.cod_bucket": "Чакадагы треска",
  "item.minecraft.cod_spawn_egg": "Треска жаратуу жумурткасы",
  "item.minecraft.command_block_minecart": "Командалык блок вагончосу",
  "item.minecraft.compass": "Кыбыла нама",
  "item.minecraft.cooked_beef": "Стейк",
  "item.minecraft.cooked_chicken": "Бышкан тоок эти",
  "item.minecraft.cooked_cod": "Бышкан треска",
  "item.minecraft.cooked_mutton": "Бышкан кой эти",
  "item.minecraft.cooked_porkchop": "Бышкан чочко эти",
  "item.minecraft.cooked_rabbit": "Бышкан коён эти",
  "item.minecraft.cooked_salmon": "Бышкан сом балык",
  "item.minecraft.cookie": "Печенье",
  "item.minecraft.copper_axe": "Жез балта",
  "item.minecraft.copper_boots": "Жез өтүк",
  "item.minecraft.copper_chestplate": "Жез соот",
  "item.minecraft.copper_golem_spawn_egg": "Жез голем жаратуу жумурткасы",
  "item.minecraft.copper_helmet": "Жез туулга",
  "item.minecraft.copper_hoe": "Жез кетмен",
  "item.minecraft.copper_horse_armor": "Жез ат сооту",
  "item.minecraft.copper_ingot": "Жез куйма",
  "item.minecraft.copper_leggings": "Жез шым",
  "item.minecraft.copper_nautilus_armor": "Жез наутилус сооту",
  "item.minecraft.copper_nugget": "Жез кесеги",
  "item.minecraft.copper_pickaxe": "Жез чукулдук",
  "item.minecraft.copper_shovel": "Жез күрөк",
  "item.minecraft.copper_spear": "Жез найза",
  "item.minecraft.copper_sword": "Жез кылыч",
  "item.minecraft.cow_spawn_egg": "Уй жаратуу жумурткасы",
  "item.minecraft.creaking_spawn_egg": "Кычырак жаратуу жумурткасы",
  "item.minecraft.creeper_banner_pattern": "Желек оймосу",
  "item.minecraft.creeper_banner_pattern.desc": "Крипер",
  "item.minecraft.creeper_banner_pattern.new": "«Крипер» желек оймосу",
  "item.minecraft.creeper_spawn_egg": "Крипер жаратуу жумурткасы",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Ок:",
  "item.minecraft.crossbow.projectile.multiple": "Ок: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Ок: %s",
  "item.minecraft.cyan_bundle": "Көгүш кап",
  "item.minecraft.cyan_dye": "Көгүш боёгуч",
  "item.minecraft.cyan_harness": "Көгүш гаст жабдыгы",
  "item.minecraft.danger_pottery_shard": "«Коркунуч» кумара сыныгы",
  "item.minecraft.danger_pottery_sherd": "«Коркунуч» кумара сыныгы",
  "item.minecraft.dark_oak_boat": "Кара эмен кайык",
  "item.minecraft.dark_oak_chest_boat": "Сандыктуу кара эмен кайык",
  "item.minecraft.debug_stick": "Түзөтүү таягы",
  "item.minecraft.debug_stick.empty": "%s эч сапаты жок",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) тандалды",
  "item.minecraft.debug_stick.update": "\"%s\" ‐> %s",
  "item.minecraft.diamond": "Алмаз",
  "item.minecraft.diamond_axe": "Алмаз балта",
  "item.minecraft.diamond_boots": "Алмаз өтүк",
  "item.minecraft.diamond_chestplate": "Алмаз соот",
  "item.minecraft.diamond_helmet": "Алмаз туулга",
  "item.minecraft.diamond_hoe": "Алмаз кетмен",
  "item.minecraft.diamond_horse_armor": "Алмаз ат сооту",
  "item.minecraft.diamond_leggings": "Алмаз шым",
  "item.minecraft.diamond_nautilus_armor": "Алмаз наутилус сооту",
  "item.minecraft.diamond_pickaxe": "Алмаз чукулдук",
  "item.minecraft.diamond_shovel": "Алмаз күрөк",
  "item.minecraft.diamond_spear": "Алмаз найза",
  "item.minecraft.diamond_sword": "Алмаз кылыч",
  "item.minecraft.disc_fragment_5": "Музыкалык табактын сыныгы",
  "item.minecraft.disc_fragment_5.desc": "Музыкалык табак — 5",
  "item.minecraft.dolphin_spawn_egg": "Дельфин жаратуу жумурткасы",
  "item.minecraft.donkey_spawn_egg": "Эшек жаратуу жумурткасы",
  "item.minecraft.dragon_breath": "Ажыдаар деми",
  "item.minecraft.dried_kelp": "Кургатылган ламинария",
  "item.minecraft.drowned_spawn_egg": "Чөккүн жаратуу жумурткасы",
  "item.minecraft.dune_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.dune_armor_trim_smithing_template.new": "«Дөң» оюусу",
  "item.minecraft.echo_shard": "Жаңырык сыныгы",
  "item.minecraft.egg": "Жумуртка",
  "item.minecraft.elder_guardian_spawn_egg": "Байыркы коргоочу жаратуу жумурткасы",
  "item.minecraft.elytra": "Элитра",
  "item.minecraft.emerald": "Зумурут",
  "item.minecraft.enchanted_book": "Сыйкырланган китеп",
  "item.minecraft.enchanted_golden_apple": "Сыйкырланган алтын алма",
  "item.minecraft.end_crystal": "Энд кристалы",
  "item.minecraft.ender_dragon_spawn_egg": "Ажыдаар жаратуу жумурткасы",
  "item.minecraft.ender_eye": "Эндер көзү",
  "item.minecraft.ender_pearl": "Эндер бермети",
  "item.minecraft.enderman_spawn_egg": "Эндермен жаратуу жумурткасы",
  "item.minecraft.endermite_spawn_egg": "Эндермит жаратуу жумурткасы",
  "item.minecraft.evoker_spawn_egg": "Дубалоочу жаратуу жумурткасы",
  "item.minecraft.experience_bottle": "Сыйкырлоо бөтөлкөсү",
  "item.minecraft.explorer_pottery_shard": "«Изилдөөчү» кумара сыныгы",
  "item.minecraft.explorer_pottery_sherd": "«Изилдөөчү» кумара сыныгы",
  "item.minecraft.eye_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.eye_armor_trim_smithing_template.new": "«Көз» оюусу",
  "item.minecraft.feather": "Чалгын",
  "item.minecraft.fermented_spider_eye": "Ачытылган жөргөмүштүн көзү",
  "item.minecraft.field_masoned_banner_pattern": "«Кирпич» желек оймосу",
  "item.minecraft.filled_map": "Карта",
  "item.minecraft.fire_charge": "От шары",
  "item.minecraft.firework_rocket": "Фейерверк",
  "item.minecraft.firework_rocket.flight": "Учуу узактыгы:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Фейерверк жылдызы",
  "item.minecraft.firework_star.black": "Кара",
  "item.minecraft.firework_star.blue": "Көк",
  "item.minecraft.firework_star.brown": "Күрөң",
  "item.minecraft.firework_star.custom_color": "Колдонуучу",
  "item.minecraft.firework_star.cyan": "Көгүш",
  "item.minecraft.firework_star.fade_to": "Өчүү түсү",
  "item.minecraft.firework_star.flicker": "Жылтыл",
  "item.minecraft.firework_star.gray": "Боз",
  "item.minecraft.firework_star.green": "Жашыл",
  "item.minecraft.firework_star.light_blue": "Көгүлтүр",
  "item.minecraft.firework_star.light_gray": "Ачык боз",
  "item.minecraft.firework_star.lime": "Лайм",
  "item.minecraft.firework_star.magenta": "Кара кочкул",
  "item.minecraft.firework_star.orange": "Кызгылт сары",
  "item.minecraft.firework_star.pink": "Кызгылт",
  "item.minecraft.firework_star.purple": "Кызгылт көк",
  "item.minecraft.firework_star.red": "Кызыл",
  "item.minecraft.firework_star.shape": "Белгисиз тариз",
  "item.minecraft.firework_star.shape.burst": "Чачуу",
  "item.minecraft.firework_star.shape.creeper": "Крипер сыяктуу",
  "item.minecraft.firework_star.shape.large_ball": "Чоң шар",
  "item.minecraft.firework_star.shape.small_ball": "Кичи шар",
  "item.minecraft.firework_star.shape.star": "Жылдыз сыяктуу",
  "item.minecraft.firework_star.trail": "Из",
  "item.minecraft.firework_star.white": "Ак",
  "item.minecraft.firework_star.yellow": "Сары",
  "item.minecraft.fishing_rod": "Кайырмак",
  "item.minecraft.flint": "Оттук таш",
  "item.minecraft.flint_and_steel": "Оттук",
  "item.minecraft.flow_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.flow_armor_trim_smithing_template.new": "«Агым» оюусу",
  "item.minecraft.flow_banner_pattern": "Желек оймосу",
  "item.minecraft.flow_banner_pattern.desc": "Агым",
  "item.minecraft.flow_banner_pattern.new": "«Агым» желек оймосу",
  "item.minecraft.flow_pottery_sherd": "«Агын» кумара сыныгы",
  "item.minecraft.flower_banner_pattern": "Желек оймосу",
  "item.minecraft.flower_banner_pattern.desc": "Гүл",
  "item.minecraft.flower_banner_pattern.new": "«Гүл» желек оймосу",
  "item.minecraft.flower_pot": "Гүл карапасы",
  "item.minecraft.fox_spawn_egg": "Түлкү жаратуу жумурткасы",
  "item.minecraft.friend_pottery_shard": "«Дос» кумара сыныгы",
  "item.minecraft.friend_pottery_sherd": "«Дос» кумара сыныгы",
  "item.minecraft.frog_spawn_egg": "Бака жаратуу жумурткасы",
  "item.minecraft.furnace_minecart": "Меш бар вагончо",
  "item.minecraft.ghast_spawn_egg": "Гаст жаратуу жумурткасы",
  "item.minecraft.ghast_tear": "Гаст көз жашы",
  "item.minecraft.glass_bottle": "Бөтөлкө",
  "item.minecraft.glistering_melon_slice": "Жалтырак дарбыз кесими",
  "item.minecraft.globe_banner_pattern": "Желек оймосу",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "«Глобус» желек оймосу",
  "item.minecraft.glow_berries": "Жалтырак мөмө",
  "item.minecraft.glow_ink_sac": "Жалтыр сыя",
  "item.minecraft.glow_item_frame": "Жалтырак сүрөт жээги",
  "item.minecraft.glow_squid_spawn_egg": "Жалтырак сегиз бут жаратуу жумурткасы",
  "item.minecraft.glowstone_dust": "Жарык таш күкүмү",
  "item.minecraft.goat_horn": "Эчкинин мүйүзү",
  "item.minecraft.goat_spawn_egg": "Эчки жаратуу жумурткасы",
  "item.minecraft.gold_ingot": "Алтын куйма",
  "item.minecraft.gold_nugget": "Алтын кесек",
  "item.minecraft.golden_apple": "Алтын алма",
  "item.minecraft.golden_axe": "Алтын балта",
  "item.minecraft.golden_boots": "Алтын өтүк",
  "item.minecraft.golden_carrot": "Алтын сабиз",
  "item.minecraft.golden_chestplate": "Алтын соот",
  "item.minecraft.golden_helmet": "Алтын туулга",
  "item.minecraft.golden_hoe": "Алтын кетмен",
  "item.minecraft.golden_horse_armor": "Алтын ат сооту",
  "item.minecraft.golden_leggings": "Алтын шым",
  "item.minecraft.golden_nautilus_armor": "Алтын наутилус сооту",
  "item.minecraft.golden_pickaxe": "Алтын чукулдук",
  "item.minecraft.golden_shovel": "Алтын күрөк",
  "item.minecraft.golden_spear": "Алтын найза",
  "item.minecraft.golden_sword": "Алтын кылыч",
  "item.minecraft.gray_bundle": "Боз кап",
  "item.minecraft.gray_dye": "Боз боёгуч",
  "item.minecraft.gray_harness": "Боз гаст жабдыгы",
  "item.minecraft.green_bundle": "Жашыл кап",
  "item.minecraft.green_dye": "Жашыл боёгуч",
  "item.minecraft.green_harness": "Жашыл гаст жабдыгы",
  "item.minecraft.guardian_spawn_egg": "Коргоочу жаратуу жумурткасы",
  "item.minecraft.gunpowder": "Дары",
  "item.minecraft.guster_banner_pattern": "Желек оймосу",
  "item.minecraft.guster_banner_pattern.desc": "Куюн",
  "item.minecraft.guster_banner_pattern.new": "«Куюн» желек оймосу",
  "item.minecraft.guster_pottery_sherd": "«Куюн» кумара сыныгы",
  "item.minecraft.happy_ghast_spawn_egg": "Бактылуу гаст жаратуу жумурткасы",
  "item.minecraft.harness": "Гаст жабдыгы",
  "item.minecraft.heart_of_the_sea": "Деңиз жүрөгү",
  "item.minecraft.heart_pottery_shard": "«Жүрөк» кумара сыныгы",
  "item.minecraft.heart_pottery_sherd": "«Жүрөк» кумара сыныгы",
  "item.minecraft.heartbreak_pottery_shard": "«Жарылган жүрөк» кумара сыныгы",
  "item.minecraft.heartbreak_pottery_sherd": "«Жарылган жүрөк» кумара сыныгы",
  "item.minecraft.hoglin_spawn_egg": "Хоглин жаратуу жумурткасы",
  "item.minecraft.honey_bottle": "Бал бөтөлкөсү",
  "item.minecraft.honeycomb": "Аары уячасы",
  "item.minecraft.hopper_minecart": "Куйгуч вагончосу",
  "item.minecraft.horse_spawn_egg": "Ат жаратуу жумурткасы",
  "item.minecraft.host_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.host_armor_trim_smithing_template.new": "«Башчы» оюусу",
  "item.minecraft.howl_pottery_shard": "«Улуу» кумара сыныгы",
  "item.minecraft.howl_pottery_sherd": "«Улуу» кумара сыныгы",
  "item.minecraft.husk_spawn_egg": "Өлүк жаратуу жумурткасы",
  "item.minecraft.ink_sac": "Сыя",
  "item.minecraft.iron_axe": "Темир балта",
  "item.minecraft.iron_boots": "Темир өтүк",
  "item.minecraft.iron_chestplate": "Темир соот",
  "item.minecraft.iron_golem_spawn_egg": "Темир голем жаратуу жумурткасы",
  "item.minecraft.iron_helmet": "Темир туулга",
  "item.minecraft.iron_hoe": "Темир кетмен",
  "item.minecraft.iron_horse_armor": "Темир ат сооту",
  "item.minecraft.iron_ingot": "Темир куйма",
  "item.minecraft.iron_leggings": "Темир шым",
  "item.minecraft.iron_nautilus_armor": "Темир наутилус сооту",
  "item.minecraft.iron_nugget": "Темир кесек",
  "item.minecraft.iron_pickaxe": "Темир чукулдук",
  "item.minecraft.iron_shovel": "Темир күрөк",
  "item.minecraft.iron_spear": "Темир найза",
  "item.minecraft.iron_sword": "Темир кылыч",
  "item.minecraft.item_frame": "Сүрөт жээги",
  "item.minecraft.jungle_boat": "Жеңгел кайык",
  "item.minecraft.jungle_chest_boat": "Сандыктуу жеңгел кайык",
  "item.minecraft.knowledge_book": "Билим китеби",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Лава чакасы",
  "item.minecraft.lead": "Чылбыр",
  "item.minecraft.leather": "Тери",
  "item.minecraft.leather_boots": "Булгаары өтүк",
  "item.minecraft.leather_chestplate": "Булгаары соот",
  "item.minecraft.leather_helmet": "Булгаары туулга",
  "item.minecraft.leather_horse_armor": "Булгаары ат сооту",
  "item.minecraft.leather_leggings": "Булгаары шым",
  "item.minecraft.light_blue_bundle": "Көгүлтүр кап",
  "item.minecraft.light_blue_dye": "Көгүлтүр боёгуч",
  "item.minecraft.light_blue_harness": "Көгүлтүр гаст жабдыгы",
  "item.minecraft.light_gray_bundle": "Ачык боз кап",
  "item.minecraft.light_gray_dye": "Ачык боз боёгуч",
  "item.minecraft.light_gray_harness": "Ачык боз гаст жабдыгы",
  "item.minecraft.lime_bundle": "Лайм кап",
  "item.minecraft.lime_dye": "Лайм боёгуч",
  "item.minecraft.lime_harness": "Лайм гаст жабдыгы",
  "item.minecraft.lingering_potion": "Тунма ичимдик",
  "item.minecraft.lingering_potion.effect.awkward": "Ылай тунма ичимдик",
  "item.minecraft.lingering_potion.effect.empty": "Жасалбас тунма ичимдик",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Отко каршылык тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.harming": "Зыяндык тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.healing": "Дарылануу тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.infested": "Жуктуруу тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.invisibility": "Көрүнбөстүк тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.leaping": "Секирүү тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.levitation": "Левитация тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.luck": "Ийгилик тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.mundane": "Жөнөкөй тунма ичимдик",
  "item.minecraft.lingering_potion.effect.night_vision": "Түндө көрүү тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.oozing": "Былжырдык тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.poison": "Уулануу тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.regeneration": "Регенерация тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.slow_falling": "Жай кулоо тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.slowness": "Кыбырдык тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.strength": "Күч тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.swiftness": "Ылдамдык тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.thick": "Коюу тунма ичимдик",
  "item.minecraft.lingering_potion.effect.turtle_master": "Таш бака бегинин тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.water": "Тунма суу бөтөлкөсү",
  "item.minecraft.lingering_potion.effect.water_breathing": "Сууда дем алуу тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.weakness": "Алсыздык тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.weaving": "Токуу тунма ичимдиги",
  "item.minecraft.lingering_potion.effect.wind_charged": "Жел тунма ичимдиги",
  "item.minecraft.llama_spawn_egg": "Лама жаратуу жумурткасы",
  "item.minecraft.lodestone_compass": "Магниттелген кыбыла нама",
  "item.minecraft.mace": "Чокмор",
  "item.minecraft.magenta_bundle": "Кара кочкул кап",
  "item.minecraft.magenta_dye": "Кара кочкул боёгуч",
  "item.minecraft.magenta_harness": "Кара кочкул гаст жабдыгы",
  "item.minecraft.magma_cream": "Магма креми",
  "item.minecraft.magma_cube_spawn_egg": "Магма кубу жаратуу жумурткасы",
  "item.minecraft.mangrove_boat": "Мангр кайык",
  "item.minecraft.mangrove_chest_boat": "Сандыктуу мангр кайык",
  "item.minecraft.map": "Бош карта",
  "item.minecraft.melon_seeds": "Дарбыз данеги",
  "item.minecraft.melon_slice": "Дарбыз кесими",
  "item.minecraft.milk_bucket": "Сүт чака",
  "item.minecraft.minecart": "Вагончо",
  "item.minecraft.miner_pottery_shard": "«Кенчи» кумара сыныгы",
  "item.minecraft.miner_pottery_sherd": "«Кенчи» кумара сыныгы",
  "item.minecraft.mojang_banner_pattern": "Желек оймосу",
  "item.minecraft.mojang_banner_pattern.desc": "Бирдеме",
  "item.minecraft.mojang_banner_pattern.new": "«Бирдеме» желек оймосу",
  "item.minecraft.mooshroom_spawn_egg": "Муушрум жаратуу жумурткасы",
  "item.minecraft.mourner_pottery_shard": "«Кайгы» кумара сыныгы",
  "item.minecraft.mourner_pottery_sherd": "«Кайгы» кумара сыныгы",
  "item.minecraft.mule_spawn_egg": "Качыр жаратуу жумурткасы",
  "item.minecraft.mushroom_stew": "Быктырылган козу карын",
  "item.minecraft.music_disc_11": "Музыкалык табак",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Музыкалык табак",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Музыкалык табак",
  "item.minecraft.music_disc_5.desc": "Самуел Оберг — 5",
  "item.minecraft.music_disc_blocks": "Музыкалык табак",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Музыкалык табак",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Музыкалык табак",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Музыкалык табак",
  "item.minecraft.music_disc_creator.desc": "Лина Рейн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Музыкалык табак",
  "item.minecraft.music_disc_creator_music_box.desc": "Лина Рейн — Creator (Музыкалык кутуча)",
  "item.minecraft.music_disc_far": "Музыкалык табак",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Музыкалык табак",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Музыкалык табак",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Музыкалык табак",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Музыкалык табак",
  "item.minecraft.music_disc_otherside.desc": "Лина Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Музыкалык табак",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Музыкалык табак",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Музыкалык табак",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Музыкалык табак",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Музыкалык табак",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Музыкалык табак",
  "item.minecraft.music_disc_tears.desc": "Эймос Родди — Tears",
  "item.minecraft.music_disc_wait": "Музыкалык табак",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Музыкалык табак",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Чийки кой эти",
  "item.minecraft.name_tag": "Тамга",
  "item.minecraft.nautilus_shell": "Наутилус кабыгы",
  "item.minecraft.nautilus_spawn_egg": "Наутилус жаратуу жумурткасы",
  "item.minecraft.nether_brick": "Незер кирпичи",
  "item.minecraft.nether_star": "Незер жылдызы",
  "item.minecraft.nether_wart": "Незер чору",
  "item.minecraft.netherite_axe": "Незерит балта",
  "item.minecraft.netherite_boots": "Незерит өтүк",
  "item.minecraft.netherite_chestplate": "Незерит соот",
  "item.minecraft.netherite_helmet": "Незерит туулга",
  "item.minecraft.netherite_hoe": "Незерит кетмен",
  "item.minecraft.netherite_horse_armor": "Незерит ат сооту",
  "item.minecraft.netherite_ingot": "Незерит куйма",
  "item.minecraft.netherite_leggings": "Незерит шым",
  "item.minecraft.netherite_nautilus_armor": "Незерит наутилус сооту",
  "item.minecraft.netherite_pickaxe": "Незерит чукулдук",
  "item.minecraft.netherite_scrap": "Незерит сыныгы",
  "item.minecraft.netherite_shovel": "Незерит күрөк",
  "item.minecraft.netherite_spear": "Незерит найза",
  "item.minecraft.netherite_sword": "Незерит кылыч",
  "item.minecraft.netherite_upgrade_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Незерит жакшыртуусу",
  "item.minecraft.oak_boat": "Эмен кайык",
  "item.minecraft.oak_chest_boat": "Сандыктуу эмен кайык",
  "item.minecraft.ocelot_spawn_egg": "Оцелот жаратуу жумурткасы",
  "item.minecraft.ominous_bottle": "Коркунучтуу бөтөлкө",
  "item.minecraft.ominous_trial_key": "Коркунучтуу сыноо ачкычы",
  "item.minecraft.orange_bundle": "Кызгылт сары кап",
  "item.minecraft.orange_dye": "Кызгылт сары боёгуч",
  "item.minecraft.orange_harness": "Кызгылт сары гаст жабдыгы",
  "item.minecraft.painting": "Сүрөт",
  "item.minecraft.pale_oak_boat": "Куу эмен кайык",
  "item.minecraft.pale_oak_chest_boat": "Сандыктуу куу эмен кайык",
  "item.minecraft.panda_spawn_egg": "Панда жаратуу жумурткасы",
  "item.minecraft.paper": "Кагаз",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Тоту куш жаратуу жумурткасы",
  "item.minecraft.phantom_membrane": "Фантом жаргагы",
  "item.minecraft.phantom_spawn_egg": "Фантом жаратуу жумурткасы",
  "item.minecraft.pig_spawn_egg": "Чочко жаратуу жумурткасы",
  "item.minecraft.piglin_banner_pattern": "Желек оймосу",
  "item.minecraft.piglin_banner_pattern.desc": "Тумшук",
  "item.minecraft.piglin_banner_pattern.new": "«Тумшук» желек оймосу",
  "item.minecraft.piglin_brute_spawn_egg": "Каардуу пиглин жаратуу жумурткасы",
  "item.minecraft.piglin_spawn_egg": "Пиглин жаратуу жумурткасы",
  "item.minecraft.pillager_spawn_egg": "Каракчы жаратуу жумурткасы",
  "item.minecraft.pink_bundle": "Кызгылт кап",
  "item.minecraft.pink_dye": "Кызгылт боёгуч",
  "item.minecraft.pink_harness": "Кызгылт гаст жабдыгы",
  "item.minecraft.pitcher_plant": "Кумган гүл",
  "item.minecraft.pitcher_pod": "Кумган гүл саадагы",
  "item.minecraft.plenty_pottery_shard": "«Береке» кумара сыныгы",
  "item.minecraft.plenty_pottery_sherd": "«Береке» кумара сыныгы",
  "item.minecraft.poisonous_potato": "Уу картөшкө",
  "item.minecraft.polar_bear_spawn_egg": "Ак аюу жаратуу жумурткасы",
  "item.minecraft.popped_chorus_fruit": "Бышкан корус жемиши",
  "item.minecraft.porkchop": "Чийки чочко эти",
  "item.minecraft.potato": "Картөшкө",
  "item.minecraft.potion": "Ичимдик",
  "item.minecraft.potion.effect.awkward": "Чала демделген ичимдик",
  "item.minecraft.potion.effect.empty": "Жасалбас ичимдик",
  "item.minecraft.potion.effect.fire_resistance": "Отко каршылык ичимдиги",
  "item.minecraft.potion.effect.harming": "Зыяндык ичимдиги",
  "item.minecraft.potion.effect.healing": "Дарылануу ичимдиги",
  "item.minecraft.potion.effect.infested": "Жуктуруу ичимдиги",
  "item.minecraft.potion.effect.invisibility": "Көрүнбөстүк ичимдиги",
  "item.minecraft.potion.effect.leaping": "Секирүү ичимдиги",
  "item.minecraft.potion.effect.levitation": "Левитация ичимдиги",
  "item.minecraft.potion.effect.luck": "Ийгилик ичимдиги",
  "item.minecraft.potion.effect.mundane": "Жөнөкөй ичимдик",
  "item.minecraft.potion.effect.night_vision": "Түндө көрүү ичимдиги",
  "item.minecraft.potion.effect.oozing": "Былжырдык ичимдиги",
  "item.minecraft.potion.effect.poison": "Уулануу ичимдиги",
  "item.minecraft.potion.effect.regeneration": "Регенерация ичимдиги",
  "item.minecraft.potion.effect.slow_falling": "Жай кулоо ичимдиги",
  "item.minecraft.potion.effect.slowness": "Кыбырдык ичимдиги",
  "item.minecraft.potion.effect.strength": "Күч ичимдиги",
  "item.minecraft.potion.effect.swiftness": "Ылдамдык ичимдиги",
  "item.minecraft.potion.effect.thick": "Коюу ичимдик",
  "item.minecraft.potion.effect.turtle_master": "Таш бака күчү ичимдиги",
  "item.minecraft.potion.effect.water": "Суу бөтөлкө",
  "item.minecraft.potion.effect.water_breathing": "Сууда дем алуу ичимдиги",
  "item.minecraft.potion.effect.weakness": "Алсыздык ичимдиги",
  "item.minecraft.potion.effect.weaving": "Өрүү ичимдиги",
  "item.minecraft.potion.effect.wind_charged": "Шамал кубат ичимдиги",
  "item.minecraft.pottery_shard_archer": "«Жаачы» кумара сыныгы",
  "item.minecraft.pottery_shard_arms_up": "«Кол көтөр» кумара сыныгы",
  "item.minecraft.pottery_shard_prize": "«Сыйлык» кумара сыныгы",
  "item.minecraft.pottery_shard_skull": "«Баш сөөк» кумара сыныгы",
  "item.minecraft.powder_snow_bucket": "Борпоң кар чакасы",
  "item.minecraft.prismarine_crystals": "Призмарин кристалы",
  "item.minecraft.prismarine_shard": "Призмарин сыныгы",
  "item.minecraft.prize_pottery_shard": "«Сыйлык» кумара сыныгы",
  "item.minecraft.prize_pottery_sherd": "«Сыйлык» кумара сыныгы",
  "item.minecraft.pufferfish": "Тикен боор балык",
  "item.minecraft.pufferfish_bucket": "Чакадагы тикен боор балык",
  "item.minecraft.pufferfish_spawn_egg": "Тикен боор балык жаратуу жумурткасы",
  "item.minecraft.pumpkin_pie": "Ашкабак пирогу",
  "item.minecraft.pumpkin_seeds": "Ашкабак данеги",
  "item.minecraft.purple_bundle": "Кызгылт көк кап",
  "item.minecraft.purple_dye": "Кызгылт көк боёгуч",
  "item.minecraft.purple_harness": "Кызгылт көк гаст жабдыгы",
  "item.minecraft.quartz": "Незер кварцы",
  "item.minecraft.rabbit": "Чийки коён эти",
  "item.minecraft.rabbit_foot": "Коёндун буту",
  "item.minecraft.rabbit_hide": "Коён териси",
  "item.minecraft.rabbit_spawn_egg": "Коён жаратуу жумурткасы",
  "item.minecraft.rabbit_stew": "Быктырылган коён эти",
  "item.minecraft.raiser_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "«Жыйноочу» оюусу",
  "item.minecraft.ravager_spawn_egg": "Ойрончу жаратуу жумурткасы",
  "item.minecraft.raw_copper": "Чийки жез",
  "item.minecraft.raw_gold": "Чийки алтын",
  "item.minecraft.raw_iron": "Чийки темир",
  "item.minecraft.recovery_compass": "Кайтма кыбыла нама",
  "item.minecraft.red_bundle": "Кызыл кап",
  "item.minecraft.red_dye": "Кызыл боёгуч",
  "item.minecraft.red_harness": "Кызыл гаст жабдыгы",
  "item.minecraft.redstone": "Редстоун",
  "item.minecraft.resin_brick": "Чайыр кирпич",
  "item.minecraft.resin_clump": "Уюуган чайыр",
  "item.minecraft.rib_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.rib_armor_trim_smithing_template.new": "«Кабырга» оюусу",
  "item.minecraft.rotten_flesh": "Чирик эт",
  "item.minecraft.saddle": "Ээр",
  "item.minecraft.salmon": "Чийки сом балык",
  "item.minecraft.salmon_bucket": "Чакадагы сом балык",
  "item.minecraft.salmon_spawn_egg": "Сом балык жаратуу жумурткасы",
  "item.minecraft.scrape_pottery_sherd": "«Жонуу» кумара сыныгы",
  "item.minecraft.scute": "Калканча",
  "item.minecraft.sentry_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "«Сакчы» оюусу",
  "item.minecraft.shaper_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "«Айкелчи» оюусу",
  "item.minecraft.sheaf_pottery_shard": "«Боо» кумара сыныгы",
  "item.minecraft.sheaf_pottery_sherd": "«Боо» кумара сыныгы",
  "item.minecraft.shears": "Кайчы",
  "item.minecraft.sheep_spawn_egg": "Кой жаратуу жумурткасы",
  "item.minecraft.shelter_pottery_shard": "«Калка» кумара сыныгы",
  "item.minecraft.shelter_pottery_sherd": "«Калка» кумара сыныгы",
  "item.minecraft.shield": "Калкан",
  "item.minecraft.shield.black": "Кара калкан",
  "item.minecraft.shield.blue": "Көк калкан",
  "item.minecraft.shield.brown": "Күрөң калкан",
  "item.minecraft.shield.cyan": "Көгүш калкан",
  "item.minecraft.shield.gray": "Боз калкан",
  "item.minecraft.shield.green": "Жашыл калкан",
  "item.minecraft.shield.light_blue": "Көгүлтүр калкан",
  "item.minecraft.shield.light_gray": "Ачык боз калкан",
  "item.minecraft.shield.lime": "Лайм калкан",
  "item.minecraft.shield.magenta": "Кара кочкул калкан",
  "item.minecraft.shield.orange": "Кызгылт калкан",
  "item.minecraft.shield.pink": "Кызгылт калкан",
  "item.minecraft.shield.purple": "Кызгылт көк калкан",
  "item.minecraft.shield.red": "Кызыл калкан",
  "item.minecraft.shield.white": "Ак калкан",
  "item.minecraft.shield.yellow": "Сары калкан",
  "item.minecraft.shulker_shell": "Шалкер калканы",
  "item.minecraft.shulker_spawn_egg": "Шалкер жаратуу жумурткасы",
  "item.minecraft.sign": "Тактача",
  "item.minecraft.silence_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.silence_armor_trim_smithing_template.new": "«Жымжырт» оюусу",
  "item.minecraft.silverfish_spawn_egg": "Какач кабык жаратуу жумурткасы",
  "item.minecraft.skeleton_horse_spawn_egg": "Сүлдөр ат жаратуу жумурткасы",
  "item.minecraft.skeleton_spawn_egg": "Сүлдөр жаратуу жумурткасы",
  "item.minecraft.skull_banner_pattern": "Желек оймосу",
  "item.minecraft.skull_banner_pattern.desc": "Баш сөөк",
  "item.minecraft.skull_banner_pattern.new": "«Баш сөөк» желек оймосу",
  "item.minecraft.skull_pottery_shard": "«Баш сөөк» кумара сыныгы",
  "item.minecraft.skull_pottery_sherd": "«Баш сөөк» кумара сыныгы",
  "item.minecraft.slime_ball": "Былжыр кесеги",
  "item.minecraft.slime_spawn_egg": "Былжыр жаратуу жумурткасы",
  "item.minecraft.smithing_template": "Темирчи үлгүсү",
  "item.minecraft.smithing_template.applies_to": "Эмнеге колдонулат:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Куйма же кристалл коюңуз",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Соот",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Соот бөлүгүн коюңуз",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Куймалар жана кристаллдар",
  "item.minecraft.smithing_template.ingredients": "Ингридиенттер:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Незерит куйманы коюңуз",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмаз жарак-жабдык",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Алмаз соот, курал-жарак же аспап салыңыз",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Незерит куйма",
  "item.minecraft.smithing_template.upgrade": "Жаңыртуу: ",
  "item.minecraft.sniffer_spawn_egg": "Жыттоочу жаратуу жумурткасы",
  "item.minecraft.snort_pottery_shard": "«Бышыл» кумара сыныгы",
  "item.minecraft.snort_pottery_sherd": "«Бышыл» кумара сыныгы",
  "item.minecraft.snout_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.snout_armor_trim_smithing_template.new": "«Тумшук» оюусу",
  "item.minecraft.snow_golem_spawn_egg": "Кар голем жаратуу жумурткасы",
  "item.minecraft.snowball": "Кар тогологу",
  "item.minecraft.spectral_arrow": "Спектралдык жебе",
  "item.minecraft.spider_eye": "Жөргөмүш көзү",
  "item.minecraft.spider_spawn_egg": "Жөргөмүш жаратуу жумурткасы",
  "item.minecraft.spire_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.spire_armor_trim_smithing_template.new": "«Шиш» оюусу",
  "item.minecraft.splash_potion": "Жарылгыч ичимдик",
  "item.minecraft.splash_potion.effect.awkward": "Киргил жарылгыч ичимдик",
  "item.minecraft.splash_potion.effect.empty": "Жарылгыч жасалбас ичимдик",
  "item.minecraft.splash_potion.effect.fire_resistance": "Жарылгыч отко каршылык ичимдиги",
  "item.minecraft.splash_potion.effect.harming": "Жарылгыч зыян ичимдиги",
  "item.minecraft.splash_potion.effect.healing": "Жарылгыч дарылануу ичимдиги",
  "item.minecraft.splash_potion.effect.infested": "Жарылгыч жуктуруу ичимдиги",
  "item.minecraft.splash_potion.effect.invisibility": "Жарылгыч көрүнбөстүк ичимдиги",
  "item.minecraft.splash_potion.effect.leaping": "Жарылгыч секирүү ичимдиги",
  "item.minecraft.splash_potion.effect.levitation": "Жарылгыч левитация ичимдиги",
  "item.minecraft.splash_potion.effect.luck": "Жарылгыч ийгилик ичимдиги",
  "item.minecraft.splash_potion.effect.mundane": "Жарылгыч жөнөкөй ичимдик",
  "item.minecraft.splash_potion.effect.night_vision": "Жарылгыч түндө көрүү ичимдиги",
  "item.minecraft.splash_potion.effect.oozing": "Жарылгыч былжырдык ичимдиги",
  "item.minecraft.splash_potion.effect.poison": "Жарылгыч уулануу ичимдиги",
  "item.minecraft.splash_potion.effect.regeneration": "Жарылгыч регенерация ичимдиги",
  "item.minecraft.splash_potion.effect.slow_falling": "Жарылгыч жай кулоо ичимдиги",
  "item.minecraft.splash_potion.effect.slowness": "Жарылгыч кыбырдык ичимдиги",
  "item.minecraft.splash_potion.effect.strength": "Жарылгыч күч ичимдиги",
  "item.minecraft.splash_potion.effect.swiftness": "Жарылгыч ылдамдык ичимдиги",
  "item.minecraft.splash_potion.effect.thick": "Жарылгыч коюу ичимдик",
  "item.minecraft.splash_potion.effect.turtle_master": "Жарылгыч таш бака устаты ичимдиги",
  "item.minecraft.splash_potion.effect.water": "Жарылгыч суу бөтөлкө",
  "item.minecraft.splash_potion.effect.water_breathing": "Жарылгыч сууда дем алуу ичимдиги",
  "item.minecraft.splash_potion.effect.weakness": "Жарылгыч алсыздык ичимдиги",
  "item.minecraft.splash_potion.effect.weaving": "Жарылгыч токуу ичимдиги",
  "item.minecraft.splash_potion.effect.wind_charged": "Жарылгыч шамал кубат ичимдиги",
  "item.minecraft.spruce_boat": "Карагай кайык",
  "item.minecraft.spruce_chest_boat": "Сандыктуу карагай кайык",
  "item.minecraft.spyglass": "Дүрбү",
  "item.minecraft.squid_spawn_egg": "Сегиз бут жаратуу жумурткасы",
  "item.minecraft.stick": "Таяк",
  "item.minecraft.stone_axe": "Таш балта",
  "item.minecraft.stone_hoe": "Таш кетмен",
  "item.minecraft.stone_pickaxe": "Таш чукулдук",
  "item.minecraft.stone_shovel": "Таш күрөк",
  "item.minecraft.stone_spear": "Таш найза",
  "item.minecraft.stone_sword": "Таш кылыч",
  "item.minecraft.stray_spawn_egg": "Каңгыма жаратуу жумурткасы",
  "item.minecraft.strider_spawn_egg": "Жалын бут жаратуу жумурткасы",
  "item.minecraft.string": "Жип",
  "item.minecraft.sugar": "Кант",
  "item.minecraft.suspicious_stew": "Кызык рагу",
  "item.minecraft.sweet_berries": "Таттуу мөмө",
  "item.minecraft.tadpole_bucket": "Чакадагы көнөк баш",
  "item.minecraft.tadpole_spawn_egg": "Көнөк баш жаратуу жумурткасы",
  "item.minecraft.tide_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.tide_armor_trim_smithing_template.new": "«Толкун» оюусу",
  "item.minecraft.tipped_arrow": "Иштетилген жебе",
  "item.minecraft.tipped_arrow.effect.awkward": "Иштетилген жебе",
  "item.minecraft.tipped_arrow.effect.empty": "Жасалбас иштетилген жебе",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Отко каршылык жебеси",
  "item.minecraft.tipped_arrow.effect.harming": "Зыяндык жебеси",
  "item.minecraft.tipped_arrow.effect.healing": "Дарылоо жебеси",
  "item.minecraft.tipped_arrow.effect.infested": "Жуктуруу жебеси",
  "item.minecraft.tipped_arrow.effect.invisibility": "Көрүнбөстүк жебеси",
  "item.minecraft.tipped_arrow.effect.leaping": "Секирүү жебеси",
  "item.minecraft.tipped_arrow.effect.levitation": "Левитация жебеси",
  "item.minecraft.tipped_arrow.effect.luck": "Ийгилик жебеси",
  "item.minecraft.tipped_arrow.effect.mundane": "Иштетилген жебе",
  "item.minecraft.tipped_arrow.effect.night_vision": "Түндө көрүү жебеси",
  "item.minecraft.tipped_arrow.effect.oozing": "Былжырдык жебеси",
  "item.minecraft.tipped_arrow.effect.poison": "Уулануу жебеси",
  "item.minecraft.tipped_arrow.effect.regeneration": "Регенерация жебеси",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Жай кулоо жебеси",
  "item.minecraft.tipped_arrow.effect.slowness": "Кыбырдык жебеси",
  "item.minecraft.tipped_arrow.effect.strength": "Күч жебеси",
  "item.minecraft.tipped_arrow.effect.swiftness": "Ылдамдык жебеси",
  "item.minecraft.tipped_arrow.effect.thick": "Иштетилген жебе",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Таш бака бегинин жебеси",
  "item.minecraft.tipped_arrow.effect.water": "Жарылуучу жебе",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Сууда дем алуу жебеси",
  "item.minecraft.tipped_arrow.effect.weakness": "Алсыздык жебеси",
  "item.minecraft.tipped_arrow.effect.weaving": "Токуу жебеси",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Желденүү жебеси",
  "item.minecraft.tnt_minecart": "Динамит бар вагончо",
  "item.minecraft.torchflower_seeds": "Чырак гүл үрөнү",
  "item.minecraft.totem_of_undying": "Өлбөстүк тотеми",
  "item.minecraft.trader_llama_spawn_egg": "Соодагер ламасын жаратуу жумурткасы",
  "item.minecraft.trial_key": "Сыноо ачкычы",
  "item.minecraft.trident": "Үчүлүк",
  "item.minecraft.tropical_fish": "Тропиктик балык",
  "item.minecraft.tropical_fish_bucket": "Чакадагы тропиктик балык",
  "item.minecraft.tropical_fish_spawn_egg": "Тропиктик балык жаратуу жумурткасы",
  "item.minecraft.turtle_helmet": "Таш бака калканы",
  "item.minecraft.turtle_scute": "Таш бака калканчасы",
  "item.minecraft.turtle_spawn_egg": "Таш бака жаратуу жумурткасы",
  "item.minecraft.vex_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.vex_armor_trim_smithing_template.new": "«Зыянкеч» оюусу",
  "item.minecraft.vex_spawn_egg": "Зыянкеч жаратуу жумурткасы",
  "item.minecraft.villager_spawn_egg": "Дыйкан жаратуу жумурткасы",
  "item.minecraft.vindicator_spawn_egg": "Барымтачы жаратуу жумурткасы",
  "item.minecraft.wandering_trader_spawn_egg": "Кыдырма соодагер жаратуу жумурткасы",
  "item.minecraft.ward_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.ward_armor_trim_smithing_template.new": "«Сак» оюусу",
  "item.minecraft.warden_spawn_egg": "Сакчы жаратуу жумурткасы",
  "item.minecraft.warped_fungus_on_a_stick": "Кайырмактагы бүлдүрүлгөн козу карын",
  "item.minecraft.water_bucket": "Суу чака",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "«Жол көрсөтүүчү» оюусу",
  "item.minecraft.wheat": "Буудай",
  "item.minecraft.wheat_seeds": "Буудай үрөнү",
  "item.minecraft.white_bundle": "Ак кап",
  "item.minecraft.white_dye": "Ак боёгуч",
  "item.minecraft.white_harness": "Ак гаст жабдыгы",
  "item.minecraft.wild_armor_trim_smithing_template": "Темирчи үлгүсү",
  "item.minecraft.wild_armor_trim_smithing_template.new": "«Түпкүр» оюусу",
  "item.minecraft.wind_charge": "Жел дүрмөтү",
  "item.minecraft.witch_spawn_egg": "Жез кемпир жаратуу жумурткасы",
  "item.minecraft.wither_skeleton_spawn_egg": "Визер сүлдөр жаратуу жумурткасы",
  "item.minecraft.wither_spawn_egg": "Визер жаратуу жумурткасы",
  "item.minecraft.wolf_armor": "Карышкыр сооту",
  "item.minecraft.wolf_spawn_egg": "Карышкыр жаратуу жумурткасы",
  "item.minecraft.wooden_axe": "Жыгач балта",
  "item.minecraft.wooden_hoe": "Жыгач кетмен",
  "item.minecraft.wooden_pickaxe": "Жыгач чукулдук",
  "item.minecraft.wooden_shovel": "Жыгач күрөк",
  "item.minecraft.wooden_spear": "Жыгач найза",
  "item.minecraft.wooden_sword": "Жыгач кылыч",
  "item.minecraft.writable_book": "Китеп менен калем",
  "item.minecraft.written_book": "Жазып бүткөн китеп",
  "item.minecraft.yellow_bundle": "Сары кап",
  "item.minecraft.yellow_dye": "Сары боёгуч",
  "item.minecraft.yellow_harness": "Сары гаст жабдыгы",
  "item.minecraft.zoglin_spawn_egg": "Зоглин жаратуу жумурткасы",
  "item.minecraft.zombie_horse_spawn_egg": "Зомби ат жаратуу жумурткасы",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Зомби жаратуу жумурткасы",
  "item.minecraft.zombie_villager_spawn_egg": "Зомби дыйкан жаратуу жумурткасы",
  "item.minecraft.zombified_piglin_spawn_egg": "Зомбиленген пиглин жаратуу жумурткасы"
}
export const ky_kg = items; 
